var _path, _path2, _path3, _rect, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 125,
    viewBox: "0 0 161 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3257 63.2742C66.1112 70.6248 57.1535 73.2903 50.0593 69.3047C42.6928 65.1662 40.1666 55.5426 44.511 48.1762C48.5376 41.35 58.3332 38.7784 65.1604 42.7555C72.1797 46.8434 74.4875 56.0143 70.3247 63.2752L70.3257 63.2742Z",
    fill: "url(#paint0_linear_2453_55060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8826 16.6798C93.3237 29.2843 98.1829 37.1488 109.427 42.0978C117.525 45.6612 120.522 53.4202 117.757 60.9038C115.049 68.2344 107.779 72.1957 100.096 70.5253C92.4742 68.8686 87.1391 61.596 88.4834 53.4076C90.5337 40.9244 85.0117 33.7014 73.99 28.8379C66.3186 25.4528 63.5128 16.9003 66.4843 9.57289C69.1825 2.91765 76.6048 -0.790373 83.9797 0.832547C91.399 2.46602 96.4091 9.34074 95.8826 16.6798Z",
    fill: "url(#paint1_linear_2453_55060)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M95.8826 16.6798C93.3237 29.2843 98.1829 37.1488 109.427 42.0978C117.525 45.6612 120.522 53.4202 117.757 60.9038C115.049 68.2344 107.779 72.1957 100.096 70.5253C92.4742 68.8686 87.1391 61.596 88.4834 53.4076C90.5337 40.9244 85.0117 33.7014 73.99 28.8379C66.3186 25.4528 63.5128 16.9003 66.4843 9.57289C69.1825 2.91765 76.6048 -0.790373 83.9797 0.832547C91.399 2.46602 96.4091 9.34074 95.8826 16.6798Z",
    fill: "url(#paint2_linear_2453_55060)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 40,
    width: 31,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3257 63.2732C66.1112 70.6238 57.1535 73.2893 50.0593 69.3037C42.6928 65.1652 40.1666 55.5416 44.511 48.1752C48.5376 41.349 58.3332 38.7774 65.1604 42.7545C72.1797 46.8424 74.4875 56.0133 70.3247 63.2742L70.3257 63.2732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2453_55060)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.8394,
    y: 22.1299,
    width: 65.799,
    height: 73.54,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 33,
    width: 26,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1318 52.7951L36.0369 52.6843C37.2746 51.6354 38.2243 51.4824 39.1424 51.3347C40.0826 51.1838 40.9711 51.0413 42.1772 50.0178C43.3833 48.9963 43.6692 48.1437 43.9721 47.2426C44.2686 46.3615 44.5746 45.4498 45.8113 44.4019C47.0501 43.353 47.9998 43.2 48.9179 43.0523C49.8581 42.9004 50.7466 42.7579 51.9527 41.7343C53.1609 40.7108 53.4479 39.8582 53.7529 38.9549C54.0504 38.0727 54.3575 37.161 55.5963 36.1111C56.8362 35.0612 57.7859 34.9082 58.705 34.7604C59.6452 34.6085 60.5347 34.465 61.7419 33.4414L61.8369 33.5522C60.597 34.6021 59.6473 34.7551 58.7282 34.9039C57.788 35.0559 56.8985 35.1994 55.6913 36.223C54.4831 37.2465 54.1961 38.0991 53.8911 39.0024C53.5935 39.8846 53.2865 40.7963 52.0476 41.8462C50.8088 42.8951 49.8591 43.0481 48.9411 43.1969C48.0009 43.3488 47.1124 43.4913 45.9063 44.5138C44.7002 45.5363 44.4132 46.3878 44.1103 47.29C43.8138 48.1712 43.5078 49.0818 42.2721 50.1296C41.0333 51.1785 40.0836 51.3315 39.1656 51.4793C38.2254 51.6301 37.3379 51.7726 36.1318 52.7951Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4114 33.4424H42.3228V52.795H42.4114V33.4424Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5003 33.4424H42.4116V52.795H42.5003V33.4424Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5879 33.4424H42.4993V52.795H42.5879V33.4424Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6763 33.4424H42.5876V52.795H42.6763V33.4424Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7649 33.4424H42.6763V52.795H42.7649V33.4424Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8538 33.4424H42.7651V52.795H42.8538V33.4424Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9414 33.4424H42.8528V52.795H42.9414V33.4424Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0298 33.4424H42.9412V52.795H43.0298V33.4424Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1184 33.4424H43.0298V52.795H43.1184V33.4424Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2073 33.4424H43.1187V52.795H43.2073V33.4424Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2947 33.4424H43.2061V52.795H43.2947V33.4424Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3833 33.4424H43.2947V52.795H43.3833V33.4424Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4722 33.4424H43.3835V52.795H43.4722V33.4424Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5606 33.4424H43.4719V52.795H43.5606V33.4424Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.648 33.4424H43.5593V52.795H43.648V33.4424Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7368 33.4424H43.6482V52.795H43.7368V33.4424Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8257 33.4424H43.7371V52.795H43.8257V33.4424Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9129 33.4424H43.8242V52.795H43.9129V33.4424Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0015 33.4424H43.9128V52.795H44.0015V33.4424Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0903 33.4424H44.0017V52.795H44.0903V33.4424Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1785 33.4424H44.0898V52.795H44.1785V33.4424Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2666 33.4424H44.178V52.795H44.2666V33.4424Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3552 33.4424H44.2666V52.795H44.3552V33.4424Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4436 33.4424H44.355V52.795H44.4436V33.4424Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5322 33.4424H44.4436V52.795H44.5322V33.4424Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6196 33.4424H44.531V52.795H44.6196V33.4424Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7088 33.4424H44.6201V52.795H44.7088V33.4424Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7969 33.4424H44.7083V52.795H44.7969V33.4424Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8848 33.4424H44.7961V52.795H44.8848V33.4424Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9732 33.4424H44.8845V52.795H44.9732V33.4424Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.062 33.4424H44.9734V52.795H45.062V33.4424Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1507 33.4424H45.062V52.795H45.1507V33.4424Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2383 33.4424H45.1497V52.795H45.2383V33.4424Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3269 33.4424H45.2383V52.795H45.3269V33.4424Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4155 33.4424H45.3269V52.795H45.4155V33.4424Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5044 33.4424H45.4158V52.795H45.5044V33.4424Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5916 33.4424H45.5029V52.795H45.5916V33.4424Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6804 33.4424H45.5918V52.795H45.6804V33.4424Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7691 33.4424H45.6804V52.795H45.7691V33.4424Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8567 33.4424H45.7681V52.795H45.8567V33.4424Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9456 33.4424H45.8569V52.795H45.9456V33.4424Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0337 33.4424H45.9451V52.795H46.0337V33.4424Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1223 33.4424H46.0337V52.795H46.1223V33.4424Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.21 33.4424H46.1213V52.795H46.21V33.4424Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2986 33.4424H46.21V52.795H46.2986V33.4424Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3877 33.4424H46.2991V52.795H46.3877V33.4424Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4766 33.4424H46.3879V52.795H46.4766V33.4424Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5637 33.4424H46.4751V52.795H46.5637V33.4424Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6524 33.4424H46.5637V52.795H46.6524V33.4424Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.741 33.4424H46.6523V52.795H46.741V33.4424Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8286 33.4424H46.74V52.795H46.8286V33.4424Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9173 33.4424H46.8286V52.795H46.9173V33.4424Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0061 33.4424H46.9175V52.795H47.0061V33.4424Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0945 33.4424H47.0059V52.795H47.0945V33.4424Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1821 33.4424H47.0935V52.795H47.1821V33.4424Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2708 33.4424H47.1821V52.795H47.2708V33.4424Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3594 33.4424H47.2708V52.795H47.3594V33.4424Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4483 33.4424H47.3596V52.795H47.4483V33.4424Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5357 33.4424H47.447V52.795H47.5357V33.4424Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6245 33.4424H47.5359V52.795H47.6245V33.4424Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7129 33.4424H47.6243V52.795H47.7129V33.4424Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8013 33.4424H47.7126V52.795H47.8013V33.4424Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8889 33.4424H47.8003V52.795H47.8889V33.4424Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9773 33.4424H47.8887V52.795H47.9773V33.4424Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0662 33.4424H47.9775V52.795H48.0662V33.4424Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1538 33.4424H48.0652V52.795H48.1538V33.4424Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2424 33.4424H48.1538V52.795H48.2424V33.4424Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3311 33.4424H48.2424V52.795H48.3311V33.4424Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4194 33.4424H48.3308V52.795H48.4194V33.4424Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5076 33.4424H48.4189V52.795H48.5076V33.4424Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.596 33.4424H48.5073V52.795H48.596V33.4424Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6846 33.4424H48.5959V52.795H48.6846V33.4424Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7735 33.4424H48.6848V52.795H48.7735V33.4424Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8609 33.4424H48.7722V52.795H48.8609V33.4424Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9495 33.4424H48.8608V52.795H48.9495V33.4424Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0381 33.4424H48.9495V52.795H49.0381V33.4424Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1257 33.4424H49.0371V52.795H49.1257V33.4424Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2146 33.4424H49.126V52.795H49.2146V33.4424Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3032 33.4424H49.2146V52.795H49.3032V33.4424Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3919 33.4424H49.3032V52.795H49.3919V33.4424Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5302 33.4424H49.3909V52.795H49.5302V33.4424Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6696 33.4424H49.5303V52.795H49.6696V33.4424Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8087 33.4424H49.6694V52.795H49.8087V33.4424Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9476 33.4424H49.8083V52.795H49.9476V33.4424Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0863 33.4424H49.947V52.795H50.0863V33.4424Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2255 33.4424H50.0862V52.795H50.2255V33.4424Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3646 33.4424H50.2253V52.795H50.3646V33.4424Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5038 33.4424H50.3645V52.795H50.5038V33.4424Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6429 33.4424H50.5037V52.795H50.6429V33.4424Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7816 33.4424H50.6423V52.795H50.7816V33.4424Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9208 33.4424H50.7815V52.795H50.9208V33.4424Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0599 33.4424H50.9207V52.795H51.0599V33.4424Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1991 33.4424H51.0598V52.795H51.1991V33.4424Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3378 33.4424H51.1985V52.795H51.3378V33.4424Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4767 33.4424H51.3374V52.795H51.4767V33.4424Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6159 33.4424H51.4766V52.795H51.6159V33.4424Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7553 33.4424H51.616V52.795H51.7553V33.4424Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8937 33.4424H51.7544V52.795H51.8937V33.4424Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0328 33.4424H51.8936V52.795H52.0328V33.4424Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.172 33.4424H52.0327V52.795H52.172V33.4424Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3119 33.4424H52.1726V52.795H52.3119V33.4424Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4511 33.4424H52.3118V52.795H52.4511V33.4424Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.589 33.4424H52.4497V52.795H52.589V33.4424Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7279 33.4424H52.5886V52.795H52.7279V33.4424Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8676 33.4424H52.7283V52.795H52.8676V33.4424Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0072 33.4424H52.8679V52.795H53.0072V33.4424Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1447 33.4424H53.0054V52.795H53.1447V33.4424Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2838 33.4424H53.1445V52.795H53.2838V33.4424Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.424 33.4424H53.2847V52.795H53.424V33.4424Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5631 33.4424H53.4238V52.795H53.5631V33.4424Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7011 33.4424H53.5618V52.795H53.7011V33.4424Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8407 33.4424H53.7014V52.795H53.8407V33.4424Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9799 33.4424H53.8406V52.795H53.9799V33.4424Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1188 33.4424H53.9795V52.795H54.1188V33.4424Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2572 33.4424H54.1179V52.795H54.2572V33.4424Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3969 33.4424H54.2576V52.795H54.3969V33.4424Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5358 33.4424H54.3965V52.795H54.5358V33.4424Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6752 33.4424H54.5359V52.795H54.6752V33.4424Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8143 33.4424H54.675V52.795H54.8143V33.4424Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9525 33.4424H54.8132V52.795H54.9525V33.4424Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0919 33.4424H54.9526V52.795H55.0919V33.4424Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2311 33.4424H55.0918V52.795H55.2311V33.4424Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3705 33.4424H55.2312V52.795H55.3705V33.4424Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5089 33.4424H55.3696V52.795H55.5089V33.4424Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6478 33.4424H55.5085V52.795H55.6478V33.4424Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7872 33.4424H55.6479V52.795H55.7872V33.4424Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9269 33.4424H55.7876V52.795H55.9269V33.4424Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0648 33.4424H55.9255V52.795H56.0648V33.4424Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2042 33.4424H56.0649V52.795H56.2042V33.4424Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3431 33.4424H56.2039V52.795H56.3431V33.4424Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4828 33.4424H56.3435V52.795H56.4828V33.4424Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.622 33.4424H56.4827V52.795H56.622V33.4424Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7604 33.4424H56.6211V52.795H56.7604V33.4424Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8993 33.4424H56.76V52.795H56.8993V33.4424Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0389 33.4424H56.8997V52.795H57.0389V33.4424Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1779 33.4424H57.0386V52.795H57.1779V33.4424Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3163 33.4424H57.177V52.795H57.3163V33.4424Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4557 33.4424H57.3164V52.795H57.4557V33.4424Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5949 33.4424H57.4556V52.795H57.5949V33.4424Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7343 33.4424H57.595V52.795H57.7343V33.4424Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8729 33.4424H57.7336V52.795H57.8729V33.4424Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0118 33.4424H57.8726V52.795H58.0118V33.4424Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.151 33.4424H58.0117V52.795H58.151V33.4424Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2904 33.4424H58.1511V52.795H58.2904V33.4424Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4293 33.4424H58.29V52.795H58.4293V33.4424Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5678 33.4424H58.4285V52.795H58.5678V33.4424Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7072 33.4424H58.5679V52.795H58.7072V33.4424Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8463 33.4424H58.707V52.795H58.8463V33.4424Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9855 33.4424H58.8462V52.795H58.9855V33.4424Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1239 33.4424H58.9846V52.795H59.1239V33.4424Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2633 33.4424H59.124V52.795H59.2633V33.4424Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4022 33.4424H59.2629V52.795H59.4022V33.4424Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5419 33.4424H59.4026V52.795H59.5419V33.4424Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6798 33.4424H59.5405V52.795H59.6798V33.4424Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8192 33.4424H59.6799V52.795H59.8192V33.4424Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9589 33.4424H59.8196V52.795H59.9589V33.4424Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 33.4424H59.9585V52.795H61.8378V33.4424Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 35,
    width: 27,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.478 54.7582L37.3831 54.6474C38.6208 53.5985 39.5705 53.4455 40.4886 53.2977C41.4288 53.1468 42.3162 53.0033 43.5223 51.9808C44.7284 50.9594 45.0154 50.1068 45.3183 49.2046C45.6148 48.3235 45.9208 47.4117 47.1575 46.3639C48.3963 45.315 49.346 45.162 50.2641 45.0132C51.2043 44.8613 52.0927 44.7188 53.2989 43.6963C54.5071 42.6728 54.7941 41.8202 55.0991 40.9169C55.3966 40.0347 55.7037 39.123 56.9425 38.0731C58.1824 37.0232 59.1321 36.8701 60.0512 36.7214C60.9914 36.5694 61.8799 36.4259 63.087 35.4023L63.182 35.5131C61.9432 36.5631 60.9935 36.7161 60.0744 36.8638C59.1342 37.0158 58.2447 37.1593 57.0375 38.1828C55.8293 39.2064 55.5422 40.059 55.2373 40.9623C54.9397 41.8444 54.6327 42.7561 53.3938 43.8061C52.155 44.855 51.2053 45.008 50.2873 45.1557C49.3471 45.3076 48.4586 45.4501 47.2525 46.4737C46.0464 47.4951 45.7594 48.3477 45.4565 49.2499C45.16 50.131 44.854 51.0427 43.6173 52.0906C42.3795 53.1395 41.4298 53.2925 40.5118 53.4402C39.5716 53.5911 38.6841 53.7346 37.478 54.7571V54.7582Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4319 35.4062H42.3433V54.7589H42.4319V35.4062Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52 35.4062H42.4314V54.7589H42.52V35.4062Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6084 35.4062H42.5198V54.7589H42.6084V35.4062Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6965 35.4062H42.6079V54.7589H42.6965V35.4062Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7852 35.4062H42.6965V54.7589H42.7852V35.4062Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.874 35.4062H42.7854V54.7589H42.874V35.4062Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9614 35.4062H42.8728V54.7589H42.9614V35.4062Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0501 35.4062H42.9614V54.7589H43.0501V35.4062Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1384 35.4062H43.0498V54.7589H43.1384V35.4062Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2266 35.4062H43.1379V54.7589H43.2266V35.4062Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.315 35.4062H43.2263V54.7589H43.315V35.4062Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4036 35.4062H43.3149V54.7589H43.4036V35.4062Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4924 35.4062H43.4038V54.7589H43.4924V35.4062Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5798 35.4062H43.4912V54.7589H43.5798V35.4062Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6687 35.4062H43.5801V54.7589H43.6687V35.4062Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7576 35.4062H43.6689V54.7589H43.7576V35.4062Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.846 35.4062H43.7573V54.7589H43.846V35.4062Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9331 35.4062H43.8445V54.7589H43.9331V35.4062Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.022 35.4062H43.9333V54.7589H44.022V35.4062Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1109 35.4062H44.0222V54.7589H44.1109V35.4062Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1987 35.4062H44.1101V54.7589H44.1987V35.4062Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2871 35.4062H44.1985V54.7589H44.2871V35.4062Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.376 35.4062H44.2874V54.7589H44.376V35.4062Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4644 35.4062H44.3757V54.7589H44.4644V35.4062Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5518 35.4062H44.4631V54.7589H44.5518V35.4062Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6404 35.4062H44.5518V54.7589H44.6404V35.4062Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7293 35.4062H44.6406V54.7589H44.7293V35.4062Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8169 35.4062H44.7283V54.7589H44.8169V35.4062Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9055 35.4062H44.8169V54.7589H44.9055V35.4062Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9944 35.4062H44.9058V54.7589H44.9944V35.4062Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0828 35.4062H44.9941V54.7589H45.0828V35.4062Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1704 35.4062H45.0818V54.7589H45.1704V35.4062Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.259 35.4062H45.1704V54.7589H45.259V35.4062Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3479 35.4062H45.2593V54.7589H45.3479V35.4062Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4363 35.4062H45.3477V54.7589H45.4363V35.4062Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5239 35.4062H45.4353V54.7589H45.5239V35.4062Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6126 35.4062H45.5239V54.7589H45.6126V35.4062Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7007 35.4062H45.6121V54.7589H45.7007V35.4062Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7888 35.4062H45.7002V54.7589H45.7888V35.4062Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8772 35.4062H45.7886V54.7589H45.8772V35.4062Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9658 35.4062H45.8772V54.7589H45.9658V35.4062Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0545 35.4062H45.9658V54.7589H46.0545V35.4062Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1421 35.4062H46.0535V54.7589H46.1421V35.4062Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2307 35.4062H46.1421V54.7589H46.2307V35.4062Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3191 35.4062H46.2305V54.7589H46.3191V35.4062Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4077 35.4062H46.3191V54.7589H46.4077V35.4062Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4954 35.4062H46.4067V54.7589H46.4954V35.4062Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5842 35.4062H46.4956V54.7589H46.5842V35.4062Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6729 35.4062H46.5842V54.7589H46.6729V35.4062Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7605 35.4062H46.6719V54.7589H46.7605V35.4062Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8491 35.4062H46.7605V54.7589H46.8491V35.4062Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9378 35.4062H46.8491V54.7589H46.9378V35.4062Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0264 35.4062H46.9377V54.7589H47.0264V35.4062Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1138 35.4062H47.0251V54.7589H47.1138V35.4062Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2027 35.4062H47.114V54.7589H47.2027V35.4062Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.291 35.4062H47.2024V54.7589H47.291V35.4062Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3794 35.4062H47.2908V54.7589H47.3794V35.4062Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4678 35.4062H47.3792V54.7589H47.4678V35.4062Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5559 35.4062H47.4673V54.7589H47.5559V35.4062Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6445 35.4062H47.5559V54.7589H47.6445V35.4062Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7322 35.4062H47.6436V54.7589H47.7322V35.4062Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8206 35.4062H47.7319V54.7589H47.8206V35.4062Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9094 35.4062H47.8208V54.7589H47.9094V35.4062Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9978 35.4062H47.9092V54.7589H47.9978V35.4062Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0857 35.4062H47.9971V54.7589H48.0857V35.4062Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1743 35.4062H48.0857V54.7589H48.1743V35.4062Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.263 35.4062H48.1743V54.7589H48.263V35.4062Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3521 35.4062H48.2634V54.7589H48.3521V35.4062Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.439 35.4062H48.3503V54.7589H48.439V35.4062Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5283 35.4062H48.4397V54.7589H48.5283V35.4062Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6167 35.4062H48.5281V54.7589H48.6167V35.4062Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7041 35.4062H48.6155V54.7589H48.7041V35.4062Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7927 35.4062H48.7041V54.7589H48.7927V35.4062Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8816 35.4062H48.793V54.7589H48.8816V35.4062Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9702 35.4062H48.8816V54.7589H48.9702V35.4062Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0579 35.4062H48.9692V54.7589H49.0579V35.4062Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1465 35.4062H49.0579V54.7589H49.1465V35.4062Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2351 35.4062H49.1465V54.7589H49.2351V35.4062Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3235 35.4062H49.2349V54.7589H49.3235V35.4062Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4111 35.4062H49.3225V54.7589H49.4111V35.4062Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4995 35.4062H49.4109V54.7589H49.4995V35.4062Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5884 35.4062H49.4998V54.7589H49.5884V35.4062Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.676 35.4062H49.5874V54.7589H49.676V35.4062Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7647 35.4062H49.676V54.7589H49.7647V35.4062Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8533 35.4062H49.7646V54.7589H49.8533V35.4062Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9417 35.4062H49.853V54.7589H49.9417V35.4062Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0298 35.4062H49.9412V54.7589H50.0298V35.4062Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1179 35.4062H50.0293V54.7589H50.1179V35.4062Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2066 35.4062H50.1179V54.7589H50.2066V35.4062Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2942 35.4062H50.2056V54.7589H50.2942V35.4062Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3831 35.4062H50.2944V54.7589H50.3831V35.4062Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4717 35.4062H50.3831V54.7589H50.4717V35.4062Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5603 35.4062H50.4717V54.7589H50.5603V35.4062Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6482 35.4062H50.5596V54.7589H50.6482V35.4062Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7366 35.4062H50.6479V54.7589H50.7366V35.4062Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8761 35.4062H50.7368V54.7589H50.8761V35.4062Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0148 35.4062H50.8755V54.7589H51.0148V35.4062Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1534 35.4062H51.0142V54.7589H51.1534V35.4062Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2929 35.4062H51.1536V54.7589H51.2929V35.4062Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.432 35.4062H51.2927V54.7589H51.432V35.4062Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5712 35.4062H51.4319V54.7589H51.5712V35.4062Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7096 35.4062H51.5703V54.7589H51.7096V35.4062Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8488 35.4062H51.7095V54.7589H51.8488V35.4062Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9882 35.4062H51.8489V54.7589H51.9882V35.4062Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1273 35.4062H51.988V54.7589H52.1273V35.4062Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2655 35.4062H52.1262V54.7589H52.2655V35.4062Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4049 35.4062H52.2656V54.7589H52.4049V35.4062Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5441 35.4062H52.4048V54.7589H52.5441V35.4062Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6832 35.4062H52.5439V54.7589H52.6832V35.4062Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8226 35.4062H52.6833V54.7589H52.8226V35.4062Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9608 35.4062H52.8215V54.7589H52.9608V35.4062Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1002 35.4062H52.9609V54.7589H53.1002V35.4062Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2394 35.4062H53.1001V54.7589H53.2394V35.4062Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3785 35.4062H53.2393V54.7589H53.3785V35.4062Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5167 35.4062H53.3774V54.7589H53.5167V35.4062Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6564 35.4062H53.5171V54.7589H53.6564V35.4062Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7953 35.4062H53.656V54.7589H53.7953V35.4062Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9349 35.4062H53.7957V54.7589H53.9349V35.4062Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0729 35.4062H53.9336V54.7589H54.0729V35.4062Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2123 35.4062H54.073V54.7589H54.2123V35.4062Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3519 35.4062H54.2126V54.7589H54.3519V35.4062Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4909 35.4062H54.3516V54.7589H54.4909V35.4062Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.629 35.4062H54.4897V54.7589H54.629V35.4062Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7687 35.4062H54.6294V54.7589H54.7687V35.4062Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9078 35.4062H54.7686V54.7589H54.9078V35.4062Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0468 35.4062H54.9075V54.7589H55.0468V35.4062Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1864 35.4062H55.0471V54.7589H55.1864V35.4062Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3246 35.4062H55.1853V54.7589H55.3246V35.4062Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4638 35.4062H55.3245V54.7589H55.4638V35.4062Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6032 35.4062H55.4639V54.7589H55.6032V35.4062Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7426 35.4062H55.6033V54.7589H55.7426V35.4062Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8805 35.4062H55.7412V54.7589H55.8805V35.4062Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0199 35.4062H55.8806V54.7589H56.0199V35.4062Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1593 35.4062H56.02V54.7589H56.1593V35.4062Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2982 35.4062H56.1589V54.7589H56.2982V35.4062Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4367 35.4062H56.2974V54.7589H56.4367V35.4062Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5758 35.4062H56.4365V54.7589H56.5758V35.4062Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7152 35.4062H56.5759V54.7589H56.7152V35.4062Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8549 35.4062H56.7156V54.7589H56.8549V35.4062Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9926 35.4062H56.8533V54.7589H56.9926V35.4062Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1322 35.4062H56.9929V54.7589H57.1322V35.4062Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2714 35.4062H57.1321V54.7589H57.2714V35.4062Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4105 35.4062H57.2712V54.7589H57.4105V35.4062Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5499 35.4062H57.4106V54.7589H57.5499V35.4062Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6884 35.4062H57.5491V54.7589H57.6884V35.4062Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8273 35.4062H57.688V54.7589H57.8273V35.4062Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9667 35.4062H57.8274V54.7589H57.9667V35.4062Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1063 35.4062H57.967V54.7589H58.1063V35.4062Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2445 35.4062H58.1052V54.7589H58.2445V35.4062Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3839 35.4062H58.2446V54.7589H58.3839V35.4062Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5231 35.4062H58.3838V54.7589H58.5231V35.4062Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6625 35.4062H58.5232V54.7589H58.6625V35.4062Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8004 35.4062H58.6611V54.7589H58.8004V35.4062Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9401 35.4062H58.8008V54.7589H58.9401V35.4062Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.079 35.4062H58.9397V54.7589H59.079V35.4062Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2186 35.4062H59.0793V54.7589H59.2186V35.4062Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3566 35.4062H59.2173V54.7589H59.3566V35.4062Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4962 35.4062H59.3569V54.7589H59.4962V35.4062Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6356 35.4062H59.4963V54.7589H59.6356V35.4062Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7745 35.4062H59.6353V54.7589H59.7745V35.4062Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9137 35.4062H59.7744V54.7589H59.9137V35.4062Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0521 35.4062H59.9128V54.7589H60.0521V35.4062Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1915 35.4062H60.0522V54.7589H60.1915V35.4062Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3305 35.4062H60.1912V54.7589H60.3305V35.4062Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4699 35.4062H60.3306V54.7589H60.4699V35.4062Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6083 35.4062H60.469V54.7589H60.6083V35.4062Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7472 35.4062H60.6079V54.7589H60.7472V35.4062Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8866 35.4062H60.7473V54.7589H60.8866V35.4062Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.026 35.4062H60.8867V54.7589H61.026V35.4062Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1642 35.4062H61.0249V54.7589H61.1642V35.4062Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3036 35.4062H61.1643V54.7589H61.3036V35.4062Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1826 35.4062H61.3032V54.7589H63.1826V35.4062Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 37,
    width: 27,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8235 56.7229L38.7285 56.6121C39.9663 55.5632 40.916 55.4102 41.834 55.2625C42.7742 55.1116 43.6627 54.9681 44.8688 53.9456C46.0749 52.9241 46.3619 52.0715 46.6648 51.1693C46.9602 50.2882 47.2673 49.3765 48.503 48.3287C49.7418 47.2798 50.6915 47.1268 51.6095 46.9791C52.5497 46.8271 53.4382 46.6847 54.6443 45.6611C55.8525 44.6375 56.1396 43.7849 56.4445 42.8817C56.7421 41.9995 57.0492 41.0878 58.288 40.0379C59.5279 38.9879 60.4776 38.8349 61.3966 38.6872C62.3368 38.5352 63.2264 38.3917 64.4335 37.3682L64.5285 37.479C63.2886 38.5289 62.3389 38.6819 61.4199 38.8307C60.4797 38.9826 59.5901 39.1262 58.3829 40.1497C57.1747 41.1733 56.8877 42.0259 56.5828 42.9291C56.2852 43.8113 55.9781 44.723 54.7393 45.7729C53.5005 46.8218 52.5508 46.9748 51.6327 47.1236C50.6925 47.2756 49.8051 47.418 48.5979 48.4405C47.3918 49.463 47.1048 50.3146 46.802 51.2168C46.5065 52.0979 46.1994 53.0096 44.9638 54.0574C43.725 55.1063 42.7753 55.2593 41.8572 55.4071C40.9181 55.5579 40.0296 55.7015 38.8235 56.724V56.7229Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3356 37.3691H38.7285V56.7228H43.3356V37.3691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4243 37.3691H43.3357V56.7228H43.4243V37.3691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5127 37.3691H43.4241V56.7228H43.5127V37.3691Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6016 37.3691H43.5129V56.7228H43.6016V37.3691Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6892 37.3691H43.6006V56.7228H43.6892V37.3691Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7778 37.3691H43.6892V56.7228H43.7778V37.3691Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8667 37.3691H43.7781V56.7228H43.8667V37.3691Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9549 37.3691H43.8662V56.7228H43.9549V37.3691Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0427 37.3691H43.9541V56.7228H44.0427V37.3691Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1311 37.3691H44.0425V56.7228H44.1311V37.3691Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.22 37.3691H44.1313V56.7228H44.22V37.3691Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3086 37.3691H44.22V56.7228H44.3086V37.3691Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3963 37.3691H44.3076V56.7228H44.3963V37.3691Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4851 37.3691H44.3965V56.7228H44.4851V37.3691Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5733 37.3691H44.4846V56.7228H44.5733V37.3691Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6609 37.3691H44.5723V56.7228H44.6609V37.3691Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7495 37.3691H44.6609V56.7228H44.7495V37.3691Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8381 37.3691H44.7495V56.7228H44.8381V37.3691Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9268 37.3691H44.8381V56.7228H44.9268V37.3691Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0144 37.3691H44.9258V56.7228H45.0144V37.3691Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1033 37.3691H45.0146V56.7228H45.1033V37.3691Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1914 37.3691H45.1028V56.7228H45.1914V37.3691Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2803 37.3691H45.1917V56.7228H45.2803V37.3691Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3674 37.3691H45.2788V56.7228H45.3674V37.3691Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4563 37.3691H45.3677V56.7228H45.4563V37.3691Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5449 37.3691H45.4563V56.7228H45.5449V37.3691Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6326 37.3691H45.5439V56.7228H45.6326V37.3691Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7217 37.3691H45.6331V56.7228H45.7217V37.3691Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8101 37.3691H45.7214V56.7228H45.8101V37.3691Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8987 37.3691H45.8101V56.7228H45.8987V37.3691Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9861 37.3691H45.8975V56.7228H45.9861V37.3691Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.075 37.3691H45.9863V56.7228H46.075V37.3691Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1638 37.3691H46.0752V56.7228H46.1638V37.3691Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2522 37.3691H46.1636V56.7228H46.2522V37.3691Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3399 37.3691H46.2512V56.7228H46.3399V37.3691Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4285 37.3691H46.3398V56.7228H46.4285V37.3691Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5169 37.3691H46.4282V56.7228H46.5169V37.3691Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6048 37.3691H46.5161V56.7228H46.6048V37.3691Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6934 37.3691H46.6047V56.7228H46.6934V37.3691Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.782 37.3691H46.6934V56.7228H46.782V37.3691Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8709 37.3691H46.7822V56.7228H46.8709V37.3691Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.958 37.3691H46.8694V56.7228H46.958V37.3691Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0471 37.3691H46.9585V56.7228H47.0471V37.3691Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1353 37.3691H47.0466V56.7228H47.1353V37.3691Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2241 37.3691H47.1355V56.7228H47.2241V37.3691Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3118 37.3691H47.2231V56.7228H47.3118V37.3691Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4004 37.3691H47.3118V56.7228H47.4004V37.3691Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.489 37.3691H47.4004V56.7228H47.489V37.3691Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5767 37.3691H47.488V56.7228H47.5767V37.3691Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6655 37.3691H47.5769V56.7228H47.6655V37.3691Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7539 37.3691H47.6653V56.7228H47.7539V37.3691Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8428 37.3691H47.7542V56.7228H47.8428V37.3691Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9299 37.3691H47.8413V56.7228H47.9299V37.3691Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0188 37.3691H47.9302V56.7228H48.0188V37.3691Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1074 37.3691H48.0188V56.7228H48.1074V37.3691Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1961 37.3691H48.1074V56.7228H48.1961V37.3691Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2837 37.3691H48.1951V56.7228H48.2837V37.3691Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3721 37.3691H48.2834V56.7228H48.3721V37.3691Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4607 37.3691H48.3721V56.7228H48.4607V37.3691Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5484 37.3691H48.4597V56.7228H48.5484V37.3691Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.637 37.3691H48.5483V56.7228H48.637V37.3691Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7256 37.3691H48.637V56.7228H48.7256V37.3691Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.814 37.3691H48.7253V56.7228H48.814V37.3691Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9021 37.3691H48.8135V56.7228H48.9021V37.3691Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9903 37.3691H48.9016V56.7228H48.9903V37.3691Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0791 37.3691H48.9905V56.7228H49.0791V37.3691Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1677 37.3691H49.0791V56.7228H49.1677V37.3691Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2554 37.3691H49.1667V56.7228H49.2554V37.3691Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.344 37.3691H49.2554V56.7228H49.344V37.3691Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4321 37.3691H49.3435V56.7228H49.4321V37.3691Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5213 37.3691H49.4326V56.7228H49.5213V37.3691Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6087 37.3691H49.52V56.7228H49.6087V37.3691Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6973 37.3691H49.6086V56.7228H49.6973V37.3691Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7859 37.3691H49.6973V56.7228H49.7859V37.3691Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8738 37.3691H49.7852V56.7228H49.8738V37.3691Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9624 37.3691H49.8738V56.7228H49.9624V37.3691Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.051 37.3691H49.9624V56.7228H50.051V37.3691Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1399 37.3691H50.0513V56.7228H50.1399V37.3691Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2268 37.3691H50.1382V56.7228H50.2268V37.3691Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3154 37.3691H50.2268V56.7228H50.3154V37.3691Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4046 37.3691H50.3159V56.7228H50.4046V37.3691Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4932 37.3691H50.4045V56.7228H50.4932V37.3691Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5808 37.3691H50.4922V56.7228H50.5808V37.3691Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6692 37.3691H50.5806V56.7228H50.6692V37.3691Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7581 37.3691H50.6694V56.7228H50.7581V37.3691Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8457 37.3691H50.7571V56.7228H50.8457V37.3691Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9343 37.3691H50.8457V56.7228H50.9343V37.3691Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0232 37.3691H50.9346V56.7228H51.0232V37.3691Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1118 37.3691H51.0232V56.7228H51.1118V37.3691Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1992 37.3691H51.1106V56.7228H51.1992V37.3691Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2876 37.3691H51.199V56.7228H51.2876V37.3691Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3765 37.3691H51.2878V56.7228H51.3765V37.3691Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4649 37.3691H51.3762V56.7228H51.4649V37.3691Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5528 37.3691H51.4641V56.7228H51.5528V37.3691Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6411 37.3691H51.5525V56.7228H51.6411V37.3691Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7302 37.3691H51.6416V56.7228H51.7302V37.3691Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8174 37.3691H51.7288V56.7228H51.8174V37.3691Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 37.3691H51.8174V56.7228H51.906V37.3691Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9946 37.3691H51.906V56.7228H51.9946V37.3691Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0833 37.3691H51.9946V56.7228H52.0833V37.3691Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2216 37.3691H52.0823V56.7228H52.2216V37.3691Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3605 37.3691H52.2212V56.7228H52.3605V37.3691Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4999 37.3691H52.3606V56.7228H52.4999V37.3691Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6393 37.3691H52.5V56.7228H52.6393V37.3691Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7777 37.3691H52.6384V56.7228H52.7777V37.3691Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9171 37.3691H52.7778V56.7228H52.9171V37.3691Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0563 37.3691H52.917V56.7228H53.0563V37.3691Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1952 37.3691H53.0559V56.7228H53.1952V37.3691Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3351 37.3691H53.1958V56.7228H53.3351V37.3691Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.473 37.3691H53.3337V56.7228H53.473V37.3691Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6122 37.3691H53.4729V56.7228H53.6122V37.3691Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7518 37.3691H53.6125V56.7228H53.7518V37.3691Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.891 37.3691H53.7517V56.7228H53.891V37.3691Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0289 37.3691H53.8896V56.7228H54.0289V37.3691Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1688 37.3691H54.0295V56.7228H54.1688V37.3691Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3077 37.3691H54.1685V56.7228H54.3077V37.3691Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4471 37.3691H54.3079V56.7228H54.4471V37.3691Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5853 37.3691H54.446V56.7228H54.5853V37.3691Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7247 37.3691H54.5854V56.7228H54.7247V37.3691Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8641 37.3691H54.7249V56.7228H54.8641V37.3691Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0033 37.3691H54.864V56.7228H55.0033V37.3691Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1425 37.3691H55.0032V56.7228H55.1425V37.3691Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2809 37.3691H55.1416V56.7228H55.2809V37.3691Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4203 37.3691H55.281V56.7228H55.4203V37.3691Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5595 37.3691H55.4202V56.7228H55.5595V37.3691Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6986 37.3691H55.5593V56.7228H55.6986V37.3691Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.837 37.3691H55.6978V56.7228H55.837V37.3691Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9762 37.3691H55.8369V56.7228H55.9762V37.3691Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1156 37.3691H55.9763V56.7228H56.1156V37.3691Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2548 37.3691H56.1155V56.7228H56.2548V37.3691Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3927 37.3691H56.2534V56.7228H56.3927V37.3691Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5321 37.3691H56.3928V56.7228H56.5321V37.3691Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6715 37.3691H56.5322V56.7228H56.6715V37.3691Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8109 37.3691H56.6716V56.7228H56.8109V37.3691Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9503 37.3691H56.811V56.7228H56.9503V37.3691Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0883 37.3691H56.949V56.7228H57.0883V37.3691Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2277 37.3691H57.0884V56.7228H57.2277V37.3691Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3668 37.3691H57.2275V56.7228H57.3668V37.3691Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5062 37.3691H57.3669V56.7228H57.5062V37.3691Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6442 37.3691H57.5049V56.7228H57.6442V37.3691Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7838 37.3691H57.6445V56.7228H57.7838V37.3691Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9232 37.3691H57.7839V56.7228H57.9232V37.3691Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0621 37.3691H57.9229V56.7228H58.0621V37.3691Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2008 37.3691H58.0615V56.7228H58.2008V37.3691Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3397 37.3691H58.2004V56.7228H58.3397V37.3691Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4789 37.3691H58.3396V56.7228H58.4789V37.3691Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6183 37.3691H58.479V56.7228H58.6183V37.3691Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7574 37.3691H58.6182V56.7228H58.7574V37.3691Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8956 37.3691H58.7563V56.7228H58.8956V37.3691Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.035 37.3691H58.8958V56.7228H59.035V37.3691Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1742 37.3691H59.0349V56.7228H59.1742V37.3691Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3134 37.3691H59.1741V56.7228H59.3134V37.3691Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4518 37.3691H59.3125V56.7228H59.4518V37.3691Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5909 37.3691H59.4517V56.7228H59.5909V37.3691Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7301 37.3691H59.5908V56.7228H59.7301V37.3691Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8698 37.3691H59.7305V56.7228H59.8698V37.3691Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0079 37.3691H59.8687V56.7228H60.0079V37.3691Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1471 37.3691H60.0078V56.7228H60.1471V37.3691Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2863 37.3691H60.147V56.7228H60.2863V37.3691Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4254 37.3691H60.2861V56.7228H60.4254V37.3691Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5651 37.3691H60.4258V56.7228H60.5651V37.3691Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7033 37.3691H60.564V56.7228H60.7033V37.3691Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8424 37.3691H60.7031V56.7228H60.8424V37.3691Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9821 37.3691H60.8428V56.7228H60.9821V37.3691Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1215 37.3691H60.9822V56.7228H61.1215V37.3691Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2592 37.3691H61.1199V56.7228H61.2592V37.3691Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3988 37.3691H61.2595V56.7228H61.3988V37.3691Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5382 37.3691H61.3989V56.7228H61.5382V37.3691Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6774 37.3691H61.5381V56.7228H61.6774V37.3691Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8158 37.3691H61.6765V56.7228H61.8158V37.3691Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.955 37.3691H61.8157V56.7228H61.955V37.3691Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0941 37.3691H61.9548V56.7228H62.0941V37.3691Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2335 37.3691H62.0942V56.7228H62.2335V37.3691Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3727 37.3691H62.2334V56.7228H62.3727V37.3691Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5109 37.3691H62.3716V56.7228H62.5109V37.3691Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6505 37.3691H62.5112V56.7228H62.6505V37.3691Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5295 37.3691H62.6501V56.7228H64.5295V37.3691Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 39,
    width: 26,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1699 58.6869L40.075 58.5761C41.3127 57.5272 42.2624 57.3742 43.1804 57.2264C44.1206 57.0755 45.0081 56.932 46.2142 55.9095C47.4203 54.8881 47.7073 54.0355 48.0102 53.1333C48.3067 52.2522 48.6127 51.3405 49.8494 50.2926C51.0882 49.2437 52.0379 49.0907 52.956 48.942C53.8962 48.79 54.7846 48.6475 55.9908 47.625C57.199 46.6015 57.486 45.7489 57.791 44.8456C58.0885 43.9634 58.3956 43.0517 59.6344 42.0018C60.8743 40.9519 61.824 40.7989 62.7431 40.6501C63.6833 40.4981 64.5728 40.3557 65.78 39.3311L65.875 39.4419C64.6351 40.4918 63.6854 40.6448 62.7663 40.7936C61.8261 40.9455 60.9366 41.088 59.7294 42.1126C58.5212 43.1362 58.2341 43.9888 57.9292 44.892C57.6316 45.7742 57.3245 46.6859 56.0857 47.7358C54.8469 48.7847 53.8972 48.9377 52.9792 49.0855C52.039 49.2374 51.1505 49.3799 49.9444 50.4034C48.7383 51.4249 48.4512 52.2775 48.1484 53.1797C47.8519 54.0608 47.5459 54.9725 46.3092 56.0203C45.0714 57.0692 44.1217 57.2222 43.2037 57.37C42.2635 57.5208 41.376 57.6644 40.1699 58.6869Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.682 39.332H40.075V58.6847H44.682V39.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7705 39.332H44.6819V58.6847H44.7705V39.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8589 39.332H44.7703V58.6847H44.8589V39.332Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.948 39.332H44.8594V58.6847H44.948V39.332Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0354 39.332H44.9468V58.6847H45.0354V39.332Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.124 39.332H45.0354V58.6847H45.124V39.332Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 39.332H45.1243V58.6847H45.2129V39.332Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3013 39.332H45.2126V58.6847H45.3013V39.332Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3892 39.332H45.3005V58.6847H45.3892V39.332Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4778 39.332H45.3892V58.6847H45.4778V39.332Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5664 39.332H45.4778V58.6847H45.5664V39.332Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6538 39.332H45.5652V58.6847H45.6538V39.332Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7424 39.332H45.6538V58.6847H45.7424V39.332Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8313 39.332H45.7427V58.6847H45.8313V39.332Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9197 39.332H45.8311V58.6847H45.9197V39.332Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0076 39.332H45.9189V58.6847H46.0076V39.332Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.096 39.332H46.0073V58.6847H46.096V39.332Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1846 39.332H46.0959V58.6847H46.1846V39.332Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2732 39.332H46.1846V58.6847H46.2732V39.332Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3609 39.332H46.2722V58.6847H46.3609V39.332Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.45 39.332H46.3613V58.6847H46.45V39.332Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5381 39.332H46.4495V58.6847H46.5381V39.332Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6255 39.332H46.5369V58.6847H46.6255V39.332Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7141 39.332H46.6255V58.6847H46.7141V39.332Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8027 39.332H46.7141V58.6847H46.8027V39.332Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8916 39.332H46.803V58.6847H46.8916V39.332Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9793 39.332H46.8906V58.6847H46.9793V39.332Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0679 39.332H46.9792V58.6847H47.0679V39.332Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1565 39.332H47.0679V58.6847H47.1565V39.332Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2446 39.332H47.156V58.6847H47.2446V39.332Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3328 39.332H47.2441V58.6847H47.3328V39.332Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4212 39.332H47.3325V58.6847H47.4212V39.332Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.51 39.332H47.4214V58.6847H47.51V39.332Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5974 39.332H47.5088V58.6847H47.5974V39.332Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6865 39.332H47.5979V58.6847H47.6865V39.332Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7752 39.332H47.6865V58.6847H47.7752V39.332Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8635 39.332H47.7749V58.6847H47.8635V39.332Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9517 39.332H47.863V58.6847H47.9517V39.332Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0396 39.332H47.9509V58.6847H48.0396V39.332Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1282 39.332H48.0396V58.6847H48.1282V39.332Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2168 39.332H48.1282V58.6847H48.2168V39.332Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3045 39.332H48.2158V58.6847H48.3045V39.332Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3933 39.332H48.3047V58.6847H48.3933V39.332Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4819 39.332H48.3933V58.6847H48.4819V39.332Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5706 39.332H48.4819V58.6847H48.5706V39.332Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6582 39.332H48.5696V58.6847H48.6582V39.332Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7471 39.332H48.6584V58.6847H48.7471V39.332Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8357 39.332H48.7471V58.6847H48.8357V39.332Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9231 39.332H48.8345V58.6847H48.9231V39.332Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0117 39.332H48.9231V58.6847H49.0117V39.332Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1001 39.332H49.0115V58.6847H49.1001V39.332Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1887 39.332H49.1001V58.6847H49.1887V39.332Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2766 39.332H49.188V58.6847H49.2766V39.332Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3652 39.332H49.2766V58.6847H49.3652V39.332Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4539 39.332H49.3652V58.6847H49.4539V39.332Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5423 39.332H49.4536V58.6847H49.5423V39.332Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6301 39.332H49.5415V58.6847H49.6301V39.332Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7185 39.332H49.6299V58.6847H49.7185V39.332Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8069 39.332H49.7183V58.6847H49.8069V39.332Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8945 39.332H49.8059V58.6847H49.8945V39.332Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9832 39.332H49.8945V58.6847H49.9832V39.332Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.072 39.332H49.9834V58.6847H50.072V39.332Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1609 39.332H50.0723V58.6847H50.1609V39.332Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2483 39.332H50.1597V58.6847H50.2483V39.332Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3367 39.332H50.248V58.6847H50.3367V39.332Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4253 39.332H50.3367V58.6847H50.4253V39.332Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5144 39.332H50.4258V58.6847H50.5144V39.332Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6018 39.332H50.5132V58.6847H50.6018V39.332Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6904 39.332H50.6018V58.6847H50.6904V39.332Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7793 39.332H50.6907V58.6847H50.7793V39.332Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8667 39.332H50.7781V58.6847H50.8667V39.332Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9551 39.332H50.8665V58.6847H50.9551V39.332Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.044 39.332H50.9553V58.6847H51.044V39.332Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1328 39.332H51.0442V58.6847H51.1328V39.332Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.22 39.332H51.1313V58.6847H51.22V39.332Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3089 39.332H51.2202V58.6847H51.3089V39.332Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3977 39.332H51.3091V58.6847H51.3977V39.332Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4856 39.332H51.397V58.6847H51.4856V39.332Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5735 39.332H51.4849V58.6847H51.5735V39.332Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6621 39.332H51.5735V58.6847H51.6621V39.332Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7507 39.332H51.6621V58.6847H51.7507V39.332Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8381 39.332H51.7495V58.6847H51.8381V39.332Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.927 39.332H51.8384V58.6847H51.927V39.332Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0161 39.332H51.9275V58.6847H52.0161V39.332Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1043 39.332H52.0156V58.6847H52.1043V39.332Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1924 39.332H52.1038V58.6847H52.1924V39.332Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2808 39.332H52.1921V58.6847H52.2808V39.332Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3692 39.332H52.2805V58.6847H52.3692V39.332Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.458 39.332H52.3694V58.6847H52.458V39.332Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5457 39.332H52.457V58.6847H52.5457V39.332Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6345 39.332H52.5459V58.6847H52.6345V39.332Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7229 39.332H52.6343V58.6847H52.7229V39.332Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8115 39.332H52.7229V58.6847H52.8115V39.332Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8989 39.332H52.8103V58.6847H52.8989V39.332Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9876 39.332H52.8989V58.6847H52.9876V39.332Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0762 39.332H52.9875V58.6847H53.0762V39.332Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1641 39.332H53.0754V58.6847H53.1641V39.332Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2527 39.332H53.1641V58.6847H53.2527V39.332Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3411 39.332H53.2524V58.6847H53.3411V39.332Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4297 39.332H53.3411V58.6847H53.4297V39.332Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5682 39.332H53.429V58.6847H53.5682V39.332Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7074 39.332H53.5681V58.6847H53.7074V39.332Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8468 39.332H53.7075V58.6847H53.8468V39.332Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.986 39.332H53.8467V58.6847H53.986V39.332Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1242 39.332H53.9849V58.6847H54.1242V39.332Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2636 39.332H54.1243V58.6847H54.2636V39.332Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4027 39.332H54.2634V58.6847H54.4027V39.332Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5419 39.332H54.4026V58.6847H54.5419V39.332Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6801 39.332H54.5408V58.6847H54.6801V39.332Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8195 39.332H54.6802V58.6847H54.8195V39.332Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9586 39.332H54.8193V58.6847H54.9586V39.332Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0983 39.332H54.959V58.6847H55.0983V39.332Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2372 39.332H55.0979V58.6847H55.2372V39.332Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3756 39.332H55.2363V58.6847H55.3756V39.332Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5148 39.332H55.3755V58.6847H55.5148V39.332Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6542 39.332H55.5149V58.6847H55.6542V39.332Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7933 39.332H55.6541V58.6847H55.7933V39.332Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9323 39.332H55.793V58.6847H55.9323V39.332Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0709 39.332H55.9316V58.6847H56.0709V39.332Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2103 39.332H56.071V58.6847H56.2103V39.332Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35 39.332H56.2107V58.6847H56.35V39.332Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4879 39.332H56.3486V58.6847H56.4879V39.332Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6268 39.332H56.4875V58.6847H56.6268V39.332Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7667 39.332H56.6274V58.6847H56.7667V39.332Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9059 39.332H56.7666V58.6847H56.9059V39.332Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0451 39.332H56.9058V58.6847H57.0451V39.332Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1835 39.332H57.0442V58.6847H57.1835V39.332Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3226 39.332H57.1833V58.6847H57.3226V39.332Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4618 39.332H57.3225V58.6847H57.4618V39.332Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 39.332H57.4619V58.6847H57.6012V39.332Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7391 39.332H57.5999V58.6847H57.7391V39.332Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8785 39.332H57.7393V58.6847H57.8785V39.332Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.018 39.332H57.8787V58.6847H58.018V39.332Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1571 39.332H58.0178V58.6847H58.1571V39.332Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2953 39.332H58.156V58.6847H58.2953V39.332Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4347 39.332H58.2954V58.6847H58.4347V39.332Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5741 39.332H58.4348V58.6847H58.5741V39.332Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7128 39.332H58.5735V58.6847H58.7128V39.332Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8524 39.332H58.7131V58.6847H58.8524V39.332Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9906 39.332H58.8513V58.6847H58.9906V39.332Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13 39.332H58.9907V58.6847H59.13V39.332Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2689 39.332H59.1296V58.6847H59.2689V39.332Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4083 39.332H59.269V58.6847H59.4083V39.332Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5465 39.332H59.4072V58.6847H59.5465V39.332Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6859 39.332H59.5466V58.6847H59.6859V39.332Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8253 39.332H59.686V58.6847H59.8253V39.332Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9645 39.332H59.8252V58.6847H59.9645V39.332Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1029 39.332H59.9636V58.6847H60.1029V39.332Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2421 39.332H60.1028V58.6847H60.2421V39.332Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3812 39.332H60.2419V58.6847H60.3812V39.332Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5206 39.332H60.3813V58.6847H60.5206V39.332Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.66 39.332H60.5208V58.6847H60.66V39.332Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7985 39.332H60.6592V58.6847H60.7985V39.332Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9376 39.332H60.7983V58.6847H60.9376V39.332Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0768 39.332H60.9375V58.6847H61.0768V39.332Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2162 39.332H61.0769V58.6847H61.2162V39.332Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3544 39.332H61.2151V58.6847H61.3544V39.332Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4933 39.332H61.354V58.6847H61.4933V39.332Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6334 39.332H61.4941V58.6847H61.6334V39.332Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7721 39.332H61.6328V58.6847H61.7721V39.332Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9103 39.332H61.771V58.6847H61.9103V39.332Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0497 39.332H61.9104V58.6847H62.0497V39.332Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1891 39.332H62.0498V58.6847H62.1891V39.332Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3285 39.332H62.1892V58.6847H62.3285V39.332Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4677 39.332H62.3284V58.6847H62.4677V39.332Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6061 39.332H62.4668V58.6847H62.6061V39.332Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.745 39.332H62.6057V58.6847H62.745V39.332Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8844 39.332H62.7451V58.6847H62.8844V39.332Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0236 39.332H62.8843V58.6847H63.0236V39.332Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1618 39.332H63.0225V58.6847H63.1618V39.332Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3014 39.332H63.1621V58.6847H63.3014V39.332Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4403 39.332H63.301V58.6847H63.4403V39.332Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.58 39.332H63.4407V58.6847H63.58V39.332Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7181 39.332H63.5789V58.6847H63.7181V39.332Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8578 39.332H63.7185V58.6847H63.8578V39.332Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9967 39.332H63.8574V58.6847H63.9967V39.332Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8759 39.332H63.9966V58.6847H65.8759V39.332Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 41,
    width: 27,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5151 60.6476L41.4202 60.5368C42.659 59.488 43.6087 59.335 44.5257 59.1872C45.4659 59.0363 46.3544 58.8928 47.5605 57.8703C48.7666 56.8478 49.0536 55.9963 49.3564 55.094C49.653 54.2129 49.959 53.3012 51.1957 52.2534C52.4345 51.2045 53.3842 51.0515 54.3012 50.9038C55.2414 50.7518 56.1299 50.6094 57.337 49.5869C58.5452 48.5633 58.8323 47.7107 59.1372 46.8074C59.4337 45.9253 59.7419 45.0136 60.9796 43.9636C62.2195 42.9137 63.1692 42.7607 64.0883 42.613C65.0285 42.461 65.918 42.3175 67.1252 41.2939L67.2202 41.4047C65.9803 42.4547 65.0306 42.6077 64.1115 42.7554C63.1713 42.9074 62.2818 43.0509 61.0746 44.0744C59.8664 45.098 59.5794 45.9506 59.2744 46.8539C58.9779 47.736 58.6698 48.6477 57.432 49.6977C56.1932 50.7466 55.2435 50.8996 54.3254 51.0473C53.3852 51.1992 52.4968 51.3417 51.2906 52.3642C50.0845 53.3867 49.7975 54.2383 49.4947 55.1405C49.1982 56.0216 48.8921 56.9333 47.6554 57.9811C46.4166 59.03 45.4669 59.183 44.5499 59.3307C43.6097 59.4816 42.7212 59.6251 41.5151 60.6476Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0277 41.2969H41.4207V60.6495H46.0277V41.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1162 41.2969H46.0276V60.6495H46.1162V41.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2053 41.2969H46.1167V60.6495H46.2053V41.2969Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.294 41.2969H46.2053V60.6495H46.294V41.2969Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3811 41.2969H46.2925V60.6495H46.3811V41.2969Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47 41.2969H46.3813V60.6495H46.47V41.2969Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5586 41.2969H46.47V60.6495H46.5586V41.2969Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6472 41.2969H46.5586V60.6495H46.6472V41.2969Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7346 41.2969H46.646V60.6495H46.7346V41.2969Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8233 41.2969H46.7346V60.6495H46.8233V41.2969Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9119 41.2969H46.8232V60.6495H46.9119V41.2969Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0007 41.2969H46.9121V60.6495H47.0007V41.2969Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0879 41.2969H46.9993V60.6495H47.0879V41.2969Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1768 41.2969H47.0881V60.6495H47.1768V41.2969Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2652 41.2969H47.1765V60.6495H47.2652V41.2969Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.353 41.2969H47.2644V60.6495H47.353V41.2969Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4417 41.2969H47.353V60.6495H47.4417V41.2969Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5303 41.2969H47.4417V60.6495H47.5303V41.2969Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6189 41.2969H47.5303V60.6495H47.6189V41.2969Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7066 41.2969H47.6179V60.6495H47.7066V41.2969Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7954 41.2969H47.7068V60.6495H47.7954V41.2969Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8838 41.2969H47.7952V60.6495H47.8838V41.2969Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9727 41.2969H47.884V60.6495H47.9727V41.2969Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0601 41.2969H47.9714V60.6495H48.0601V41.2969Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1487 41.2969H48.0601V60.6495H48.1487V41.2969Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2376 41.2969H48.1489V60.6495H48.2376V41.2969Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3252 41.2969H48.2366V60.6495H48.3252V41.2969Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4138 41.2969H48.3252V60.6495H48.4138V41.2969Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5025 41.2969H48.4138V60.6495H48.5025V41.2969Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5906 41.2969H48.502V60.6495H48.5906V41.2969Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.678 41.2969H48.5894V60.6495H48.678V41.2969Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7669 41.2969H48.6782V60.6495H48.7669V41.2969Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8555 41.2969H48.7668V60.6495H48.8555V41.2969Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9439 41.2969H48.8552V60.6495H48.9439V41.2969Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.032 41.2969H48.9434V60.6495H49.032V41.2969Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1204 41.2969H49.0317V60.6495H49.1204V41.2969Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.209 41.2969H49.1204V60.6495H49.209V41.2969Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2966 41.2969H49.208V60.6495H49.2966V41.2969Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3853 41.2969H49.2966V60.6495H49.3853V41.2969Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4739 41.2969H49.3853V60.6495H49.4739V41.2969Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.563 41.2969H49.4744V60.6495H49.563V41.2969Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6502 41.2969H49.5615V60.6495H49.6502V41.2969Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.739 41.2969H49.6504V60.6495H49.739V41.2969Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8279 41.2969H49.7393V60.6495H49.8279V41.2969Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9165 41.2969H49.8279V60.6495H49.9165V41.2969Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0042 41.2969H49.9155V60.6495H50.0042V41.2969Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0928 41.2969H50.0042V60.6495H50.0928V41.2969Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1814 41.2969H50.0928V60.6495H50.1814V41.2969Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2693 41.2969H50.1807V60.6495H50.2693V41.2969Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3577 41.2969H50.269V60.6495H50.3577V41.2969Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4456 41.2969H50.3569V60.6495H50.4456V41.2969Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5344 41.2969H50.4458V60.6495H50.5344V41.2969Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6221 41.2969H50.5334V60.6495H50.6221V41.2969Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7107 41.2969H50.6221V60.6495H50.7107V41.2969Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7996 41.2969H50.7109V60.6495H50.7996V41.2969Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.888 41.2969H50.7993V60.6495H50.888V41.2969Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9758 41.2969H50.8872V60.6495H50.9758V41.2969Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0642 41.2969H50.9756V60.6495H51.0642V41.2969Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1531 41.2969H51.0645V60.6495H51.1531V41.2969Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2417 41.2969H51.1531V60.6495H51.2417V41.2969Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3291 41.2969H51.2405V60.6495H51.3291V41.2969Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.418 41.2969H51.3293V60.6495H51.418V41.2969Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5064 41.2969H51.4177V60.6495H51.5064V41.2969Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5943 41.2969H51.5056V60.6495H51.5943V41.2969Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6829 41.2969H51.5942V60.6495H51.6829V41.2969Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7715 41.2969H51.6829V60.6495H51.7715V41.2969Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8604 41.2969H51.7717V60.6495H51.8604V41.2969Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9475 41.2969H51.8589V60.6495H51.9475V41.2969Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0361 41.2969H51.9475V60.6495H52.0361V41.2969Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1245 41.2969H52.0359V60.6495H52.1245V41.2969Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2131 41.2969H52.1245V60.6495H52.2131V41.2969Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3008 41.2969H52.2122V60.6495H52.3008V41.2969Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3894 41.2969H52.3008V60.6495H52.3894V41.2969Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4783 41.2969H52.3896V60.6495H52.4783V41.2969Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5659 41.2969H52.4773V60.6495H52.5659V41.2969Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6546 41.2969H52.5659V60.6495H52.6546V41.2969Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7427 41.2969H52.6541V60.6495H52.7427V41.2969Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8318 41.2969H52.7432V60.6495H52.8318V41.2969Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9192 41.2969H52.8306V60.6495H52.9192V41.2969Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0078 41.2969H52.9192V60.6495H53.0078V41.2969Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0967 41.2969H53.0081V60.6495H53.0967V41.2969Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1853 41.2969H53.0967V60.6495H53.1853V41.2969Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.273 41.2969H53.1843V60.6495H53.273V41.2969Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3616 41.2969H53.2729V60.6495H53.3616V41.2969Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.45 41.2969H53.3613V60.6495H53.45V41.2969Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5376 41.2969H53.449V60.6495H53.5376V41.2969Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6265 41.2969H53.5378V60.6495H53.6265V41.2969Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7151 41.2969H53.6265V60.6495H53.7151V41.2969Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8035 41.2969H53.7148V60.6495H53.8035V41.2969Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8911 41.2969H53.8025V60.6495H53.8911V41.2969Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9795 41.2969H53.8909V60.6495H53.9795V41.2969Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0686 41.2969H53.98V60.6495H54.0686V41.2969Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1572 41.2969H54.0686V60.6495H54.1572V41.2969Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2442 41.2969H54.1555V60.6495H54.2442V41.2969Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 41.2969H54.2449V60.6495H54.3335V41.2969Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4224 41.2969H54.3337V60.6495H54.4224V41.2969Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5095 41.2969H54.4209V60.6495H54.5095V41.2969Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5982 41.2969H54.5095V60.6495H54.5982V41.2969Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.687 41.2969H54.5984V60.6495H54.687V41.2969Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7756 41.2969H54.687V60.6495H54.7756V41.2969Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9139 41.2969H54.7747V60.6495H54.9139V41.2969Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0531 41.2969H54.9138V60.6495H55.0531V41.2969Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1923 41.2969H55.053V60.6495H55.1923V41.2969Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3314 41.2969H55.1921V60.6495H55.3314V41.2969Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4699 41.2969H55.3306V60.6495H55.4699V41.2969Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.609 41.2969H55.4697V60.6495H55.609V41.2969Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7484 41.2969H55.6091V60.6495H55.7484V41.2969Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8876 41.2969H55.7483V60.6495H55.8876V41.2969Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0267 41.2969H55.8875V60.6495H56.0267V41.2969Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1652 41.2969H56.0259V60.6495H56.1652V41.2969Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3041 41.2969H56.1648V60.6495H56.3041V41.2969Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4445 41.2969H56.3052V60.6495H56.4445V41.2969Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5834 41.2969H56.4441V60.6495H56.5834V41.2969Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7211 41.2969H56.5818V60.6495H56.7211V41.2969Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8602 41.2969H56.7209V60.6495H56.8602V41.2969Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0004 41.2969H56.8611V60.6495H57.0004V41.2969Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1393 41.2969H57V60.6495H57.1393V41.2969Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.277 41.2969H57.1377V60.6495H57.277V41.2969Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4169 41.2969H57.2776V60.6495H57.4169V41.2969Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5563 41.2969H57.417V60.6495H57.5563V41.2969Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6954 41.2969H57.5562V60.6495H57.6954V41.2969Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8346 41.2969H57.6953V60.6495H57.8346V41.2969Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9728 41.2969H57.8335V60.6495H57.9728V41.2969Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1122 41.2969H57.9729V60.6495H58.1122V41.2969Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2516 41.2969H58.1123V60.6495H58.2516V41.2969Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3905 41.2969H58.2512V60.6495H58.3905V41.2969Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5292 41.2969H58.3899V60.6495H58.5292V41.2969Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6683 41.2969H58.5291V60.6495H58.6683V41.2969Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8073 41.2969H58.668V60.6495H58.8073V41.2969Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9467 41.2969H58.8074V60.6495H58.9467V41.2969Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0851 41.2969H58.9458V60.6495H59.0851V41.2969Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2243 41.2969H59.085V60.6495H59.2243V41.2969Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3637 41.2969H59.2244V60.6495H59.3637V41.2969Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5026 41.2969H59.3633V60.6495H59.5026V41.2969Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.642 41.2969H59.5027V60.6495H59.642V41.2969Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7804 41.2969H59.6411V60.6495H59.7804V41.2969Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9198 41.2969H59.7805V60.6495H59.9198V41.2969Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0585 41.2969H59.9192V60.6495H60.0585V41.2969Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1984 41.2969H60.0591V60.6495H60.1984V41.2969Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3366 41.2969H60.1973V60.6495H60.3366V41.2969Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4757 41.2969H60.3364V60.6495H60.4757V41.2969Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6149 41.2969H60.4756V60.6495H60.6149V41.2969Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7538 41.2969H60.6145V60.6495H60.7538V41.2969Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8925 41.2969H60.7532V60.6495H60.8925V41.2969Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0324 41.2969H60.8931V60.6495H61.0324V41.2969Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1713 41.2969H61.032V60.6495H61.1713V41.2969Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3102 41.2969H61.1709V60.6495H61.3102V41.2969Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4496 41.2969H61.3103V60.6495H61.4496V41.2969Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.588 41.2969H61.4487V60.6495H61.588V41.2969Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7274 41.2969H61.5881V60.6495H61.7274V41.2969Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8663 41.2969H61.7271V60.6495H61.8663V41.2969Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0057 41.2969H61.8665V60.6495H62.0057V41.2969Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1442 41.2969H62.0049V60.6495H62.1442V41.2969Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2833 41.2969H62.144V60.6495H62.2833V41.2969Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4227 41.2969H62.2834V60.6495H62.4227V41.2969Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5617 41.2969H62.4224V60.6495H62.5617V41.2969Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7006 41.2969H62.5613V60.6495H62.7006V41.2969Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8395 41.2969H62.7002V60.6495H62.8395V41.2969Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9786 41.2969H62.8394V60.6495H62.9786V41.2969Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.118 41.2969H62.9788V60.6495H63.118V41.2969Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.257 41.2969H63.1177V60.6495H63.257V41.2969Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3954 41.2969H63.2561V60.6495H63.3954V41.2969Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5348 41.2969H63.3955V60.6495H63.5348V41.2969Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.674 41.2969H63.5347V60.6495H63.674V41.2969Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8138 41.2969H63.6746V60.6495H63.8138V41.2969Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9515 41.2969H63.8123V60.6495H63.9515V41.2969Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0907 41.2969H63.9514V60.6495H64.0907V41.2969Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2304 41.2969H64.0911V60.6495H64.2304V41.2969Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3698 41.2969H64.2305V60.6495H64.3698V41.2969Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5075 41.2969H64.3682V60.6495H64.5075V41.2969Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6471 41.2969H64.5078V60.6495H64.6471V41.2969Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7865 41.2969H64.6472V60.6495H64.7865V41.2969Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9257 41.2969H64.7864V60.6495H64.9257V41.2969Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0651 41.2969H64.9258V60.6495H65.0651V41.2969Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.203 41.2969H65.0637V60.6495H65.203V41.2969Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3424 41.2969H65.2031V60.6495H65.3424V41.2969Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2219 41.2969H65.3425V60.6495H67.2219V41.2969Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 43,
    width: 27,
    height: 20
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8621 62.6116L42.7671 62.5008C44.0049 61.4519 44.9546 61.2989 45.8726 61.1512C46.8128 61.0003 47.7002 60.8568 48.9063 59.8343C50.1124 58.8128 50.3995 57.9602 50.7023 57.058C50.9988 56.1769 51.3048 55.2652 52.5415 54.2174C53.7804 53.1685 54.7301 53.0155 55.6481 52.8667C56.5883 52.7158 57.4768 52.5723 58.6829 51.5498C59.8911 50.5262 60.1781 49.6736 60.4831 48.7703C60.7807 47.8882 61.0877 46.9765 62.3266 45.9265C63.5664 44.8766 64.5161 44.7236 65.4352 44.5759C66.3754 44.4239 67.265 44.2804 68.4721 43.2568L68.5671 43.3676C67.3272 44.4176 66.3775 44.5706 65.4584 44.7194C64.5182 44.8713 63.6287 45.0148 62.4215 46.0384C61.2133 47.0619 60.9263 47.9145 60.6213 48.8178C60.3238 49.7 60.0167 50.6117 58.7779 51.6616C57.539 52.7105 56.5894 52.8635 55.6713 53.0123C54.7311 53.1632 53.8426 53.3067 52.6365 54.3292C51.4304 55.3507 51.1434 56.2033 50.8405 57.1055C50.544 57.9866 50.238 58.8983 49.0013 59.9461C47.7635 60.995 46.8138 61.148 45.8958 61.2957C44.9556 61.4466 44.0682 61.5901 42.8621 62.6126V62.6116Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3742 43.2568H42.7671V62.6095H47.3742V43.2568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4624 43.2568H47.3738V62.6095H47.4624V43.2568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5513 43.2568H47.4626V62.6095H47.5513V43.2568Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6397 43.2568H47.551V62.6095H47.6397V43.2568Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7278 43.2568H47.6392V62.6095H47.7278V43.2568Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8159 43.2568H47.7273V62.6095H47.8159V43.2568Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9048 43.2568H47.8162V62.6095H47.9048V43.2568Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9937 43.2568H47.905V62.6095H47.9937V43.2568Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0808 43.2568H47.9922V62.6095H48.0808V43.2568Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1697 43.2568H48.0811V62.6095H48.1697V43.2568Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2581 43.2568H48.1694V62.6095H48.2581V43.2568Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.346 43.2568H48.2573V62.6095H48.346V43.2568Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4343 43.2568H48.3457V62.6095H48.4343V43.2568Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5232 43.2568H48.4346V62.6095H48.5232V43.2568Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6121 43.2568H48.5234V62.6095H48.6121V43.2568Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6995 43.2568H48.6108V62.6095H48.6995V43.2568Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7883 43.2568H48.6997V62.6095H48.7883V43.2568Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8765 43.2568H48.7878V62.6095H48.8765V43.2568Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9649 43.2568H48.8762V62.6095H48.9649V43.2568Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0527 43.2568H48.9641V62.6095H49.0527V43.2568Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1416 43.2568H49.053V62.6095H49.1416V43.2568Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23 43.2568H49.1414V62.6095H49.23V43.2568Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3176 43.2568H49.229V62.6095H49.3176V43.2568Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4063 43.2568H49.3176V62.6095H49.4063V43.2568Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4949 43.2568H49.4062V62.6095H49.4949V43.2568Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5835 43.2568H49.4949V62.6095H49.5835V43.2568Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6712 43.2568H49.5825V62.6095H49.6712V43.2568Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7598 43.2568H49.6711V62.6095H49.7598V43.2568Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8484 43.2568H49.7598V62.6095H49.8484V43.2568Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9373 43.2568H49.8486V62.6095H49.9373V43.2568Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0249 43.2568H49.9363V62.6095H50.0249V43.2568Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1133 43.2568H50.0247V62.6095H50.1133V43.2568Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2019 43.2568H50.1133V62.6095H50.2019V43.2568Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2908 43.2568H50.2021V62.6095H50.2908V43.2568Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3779 43.2568H50.2893V62.6095H50.3779V43.2568Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4666 43.2568H50.3779V62.6095H50.4666V43.2568Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5554 43.2568H50.4668V62.6095H50.5554V43.2568Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6431 43.2568H50.5544V62.6095H50.6431V43.2568Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7317 43.2568H50.6431V62.6095H50.7317V43.2568Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8201 43.2568H50.7314V62.6095H50.8201V43.2568Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9087 43.2568H50.8201V62.6095H50.9087V43.2568Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9966 43.2568H50.908V62.6095H50.9966V43.2568Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0852 43.2568H50.9966V62.6095H51.0852V43.2568Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1741 43.2568H51.0854V62.6095H51.1741V43.2568Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2627 43.2568H51.1741V62.6095H51.2627V43.2568Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3499 43.2568H51.2612V62.6095H51.3499V43.2568Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4387 43.2568H51.3501V62.6095H51.4387V43.2568Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5276 43.2568H51.439V62.6095H51.5276V43.2568Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.615 43.2568H51.5264V62.6095H51.615V43.2568Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7036 43.2568H51.615V62.6095H51.7036V43.2568Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7927 43.2568H51.7041V62.6095H51.7927V43.2568Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8811 43.2568H51.7925V62.6095H51.8811V43.2568Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9688 43.2568H51.8801V62.6095H51.9688V43.2568Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0569 43.2568H51.9683V62.6095H52.0569V43.2568Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1458 43.2568H52.0571V62.6095H52.1458V43.2568Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2349 43.2568H52.1462V62.6095H52.2349V43.2568Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.322 43.2568H52.2334V62.6095H52.322V43.2568Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4109 43.2568H52.3223V62.6095H52.4109V43.2568Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4993 43.2568H52.4106V62.6095H52.4993V43.2568Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5872 43.2568H52.4985V62.6095H52.5872V43.2568Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6748 43.2568H52.5862V62.6095H52.6748V43.2568Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7639 43.2568H52.6753V62.6095H52.7639V43.2568Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8528 43.2568H52.7642V62.6095H52.8528V43.2568Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9402 43.2568H52.8516V62.6095H52.9402V43.2568Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0286 43.2568H52.9399V62.6095H53.0286V43.2568Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1177 43.2568H53.0291V62.6095H53.1177V43.2568Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2061 43.2568H53.1174V62.6095H53.2061V43.2568Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2937 43.2568H53.2051V62.6095H53.2937V43.2568Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3823 43.2568H53.2937V62.6095H53.3823V43.2568Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4712 43.2568H53.3826V62.6095H53.4712V43.2568Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5586 43.2568H53.47V62.6095H53.5586V43.2568Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6472 43.2568H53.5586V62.6095H53.6472V43.2568Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7363 43.2568H53.6477V62.6095H53.7363V43.2568Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8245 43.2568H53.7358V62.6095H53.8245V43.2568Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9121 43.2568H53.8235V62.6095H53.9121V43.2568Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0007 43.2568H53.9121V62.6095H54.0007V43.2568Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0894 43.2568H54.0007V62.6095H54.0894V43.2568Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1777 43.2568H54.0891V62.6095H54.1777V43.2568Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2656 43.2568H54.177V62.6095H54.2656V43.2568Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3545 43.2568H54.2659V62.6095H54.3545V43.2568Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4429 43.2568H54.3542V62.6095H54.4429V43.2568Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5315 43.2568H54.4429V62.6095H54.5315V43.2568Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6189 43.2568H54.5303V62.6095H54.6189V43.2568Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7075 43.2568H54.6189V62.6095H54.7075V43.2568Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7964 43.2568H54.7078V62.6095H54.7964V43.2568Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8838 43.2568H54.7952V62.6095H54.8838V43.2568Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9727 43.2568H54.884V62.6095H54.9727V43.2568Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0613 43.2568H54.9727V62.6095H55.0613V43.2568Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1502 43.2568H55.0615V62.6095H55.1502V43.2568Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2373 43.2568H55.1487V62.6095H55.2373V43.2568Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3262 43.2568H55.2375V62.6095H55.3262V43.2568Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4148 43.2568H55.3262V62.6095H55.4148V43.2568Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5032 43.2568H55.4146V62.6095H55.5032V43.2568Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5913 43.2568H55.5027V62.6095H55.5913V43.2568Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6797 43.2568H55.5911V62.6095H55.6797V43.2568Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7686 43.2568H55.6799V62.6095H55.7686V43.2568Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8557 43.2568H55.7671V62.6095H55.8557V43.2568Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9448 43.2568H55.8562V62.6095H55.9448V43.2568Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0332 43.2568H55.9446V62.6095H56.0332V43.2568Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1218 43.2568H56.0332V62.6095H56.1218V43.2568Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2604 43.2568H56.1211V62.6095H56.2604V43.2568Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3993 43.2568H56.26V62.6095H56.3993V43.2568Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5382 43.2568H56.3989V62.6095H56.5382V43.2568Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6779 43.2568H56.5386V62.6095H56.6779V43.2568Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8163 43.2568H56.677V62.6095H56.8163V43.2568Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9555 43.2568H56.8162V62.6095H56.9555V43.2568Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0949 43.2568H56.9556V62.6095H57.0949V43.2568Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2338 43.2568H57.0945V62.6095H57.2338V43.2568Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3734 43.2568H57.2341V62.6095H57.3734V43.2568Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5118 43.2568H57.3726V62.6095H57.5118V43.2568Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6508 43.2568H57.5115V62.6095H57.6508V43.2568Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7902 43.2568H57.6509V62.6095H57.7902V43.2568Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9293 43.2568H57.79V62.6095H57.9293V43.2568Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0675 43.2568H57.9282V62.6095H58.0675V43.2568Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2069 43.2568H58.0676V62.6095H58.2069V43.2568Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3463 43.2568H58.207V62.6095H58.3463V43.2568Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4855 43.2568H58.3462V62.6095H58.4855V43.2568Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6239 43.2568H58.4846V62.6095H58.6239V43.2568Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7631 43.2568H58.6238V62.6095H58.7631V43.2568Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9022 43.2568H58.7629V62.6095H58.9022V43.2568Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0414 43.2568H58.9021V62.6095H59.0414V43.2568Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1805 43.2568H59.0413V62.6095H59.1805V43.2568Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.319 43.2568H59.1797V62.6095H59.319V43.2568Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4581 43.2568H59.3188V62.6095H59.4581V43.2568Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5978 43.2568H59.4585V62.6095H59.5978V43.2568Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7365 43.2568H59.5972V62.6095H59.7365V43.2568Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8751 43.2568H59.7358V62.6095H59.8751V43.2568Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0143 43.2568H59.875V62.6095H60.0143V43.2568Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1534 43.2568H60.0142V62.6095H60.1534V43.2568Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2931 43.2568H60.1538V62.6095H60.2931V43.2568Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4313 43.2568H60.292V62.6095H60.4313V43.2568Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5704 43.2568H60.4312V62.6095H60.5704V43.2568Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7094 43.2568H60.5701V62.6095H60.7094V43.2568Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8495 43.2568H60.7102V62.6095H60.8495V43.2568Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9872 43.2568H60.8479V62.6095H60.9872V43.2568Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1261 43.2568H60.9868V62.6095H61.1261V43.2568Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.266 43.2568H61.1267V62.6095H61.266V43.2568Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4054 43.2568H61.2661V62.6095H61.4054V43.2568Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5448 43.2568H61.4055V62.6095H61.5448V43.2568Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6827 43.2568H61.5435V62.6095H61.6827V43.2568Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8219 43.2568H61.6826V62.6095H61.8219V43.2568Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9616 43.2568H61.8223V62.6095H61.9616V43.2568Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1007 43.2568H61.9614V62.6095H62.1007V43.2568Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2387 43.2568H62.0994V62.6095H62.2387V43.2568Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3781 43.2568H62.2388V62.6095H62.3781V43.2568Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5175 43.2568H62.3782V62.6095H62.5175V43.2568Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6566 43.2568H62.5173V62.6095H62.6566V43.2568Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7948 43.2568H62.6555V62.6095H62.7948V43.2568Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9345 43.2568H62.7952V62.6095H62.9345V43.2568Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0734 43.2568H62.9341V62.6095H63.0734V43.2568Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2128 43.2568H63.0735V62.6095H63.2128V43.2568Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3519 43.2568H63.2126V62.6095H63.3519V43.2568Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4904 43.2568H63.3511V62.6095H63.4904V43.2568Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6295 43.2568H63.4902V62.6095H63.6295V43.2568Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7687 43.2568H63.6294V62.6095H63.7687V43.2568Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9083 43.2568H63.769V62.6095H63.9083V43.2568Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0465 43.2568H63.9072V62.6095H64.0465V43.2568Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1854 43.2568H64.0461V62.6095H64.1854V43.2568Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3248 43.2568H64.1855V62.6095H64.3248V43.2568Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4642 43.2568H64.325V62.6095H64.4642V43.2568Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6029 43.2568H64.4636V62.6095H64.6029V43.2568Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7421 43.2568H64.6028V62.6095H64.7421V43.2568Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.881 43.2568H64.7417V62.6095H64.881V43.2568Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0204 43.2568H64.8811V62.6095H65.0204V43.2568Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1593 43.2568H65.02V62.6095H65.1593V43.2568Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2982 43.2568H65.1589V62.6095H65.2982V43.2568Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4374 43.2568H65.2981V62.6095H65.4374V43.2568Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5763 43.2568H65.437V62.6095H65.5763V43.2568Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7155 43.2568H65.5762V62.6095H65.7155V43.2568Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8541 43.2568H65.7148V62.6095H65.8541V43.2568Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9933 43.2568H65.854V62.6095H65.9933V43.2568Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1325 43.2568H65.9932V62.6095H66.1325V43.2568Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2716 43.2568H66.1323V62.6095H66.2716V43.2568Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.41 43.2568H66.2708V62.6095H66.41V43.2568Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5497 43.2568H66.4104V62.6095H66.5497V43.2568Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6886 43.2568H66.5493V62.6095H66.6886V43.2568Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5681 43.2568H66.6887V62.6095H68.5681V43.2568Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 45,
    width: 26,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.207 64.5746L44.1121 64.4638C45.3509 63.4149 46.3006 63.2619 47.2186 63.1141C48.1578 62.9632 49.0462 62.8197 50.2524 61.7972C51.4585 60.7758 51.7455 59.9232 52.0483 59.021C52.3448 58.1399 52.6509 57.2281 53.8876 56.1803C55.1264 55.1314 56.0761 54.9784 56.9941 54.8296C57.9343 54.6777 58.8228 54.5352 60.0289 53.5127C61.2371 52.4892 61.5242 51.6366 61.8291 50.7333C62.1267 49.8511 62.4338 48.9394 63.6726 47.8895C64.9114 46.8396 65.8622 46.6866 66.7802 46.5378C67.7214 46.3858 68.6099 46.2423 69.8171 45.2188L69.9121 45.3295C68.6722 46.3795 67.7225 46.5325 66.8045 46.6802C65.8632 46.8322 64.9747 46.9757 63.7676 47.9992C62.5593 49.0228 62.2723 49.8754 61.9674 50.7787C61.6698 51.6608 61.3627 52.5725 60.1239 53.6225C58.8851 54.6714 57.9354 54.8244 57.0173 54.9721C56.0771 55.124 55.1887 55.2665 53.9825 56.2901C52.7764 57.3115 52.4894 58.1641 52.1866 59.0663C51.8901 59.9474 51.584 60.8591 50.3473 61.907C49.1096 62.9559 48.1599 63.1089 47.2418 63.2566C46.3016 63.4075 45.4131 63.551 44.207 64.5735V64.5746Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7196 45.2217H44.1125V64.5743H48.7196V45.2217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8079 45.2217H48.7192V64.5743H48.8079V45.2217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8965 45.2217H48.8079V64.5743H48.8965V45.2217Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9854 45.2217H48.8967V64.5743H48.9854V45.2217Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0728 45.2217H48.9841V64.5743H49.0728V45.2217Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1616 45.2217H49.073V64.5743H49.1616V45.2217Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2503 45.2217H49.1616V64.5743H49.2503V45.2217Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3389 45.2217H49.2502V64.5743H49.3389V45.2217Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4268 45.2217H49.3381V64.5743H49.4268V45.2217Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5154 45.2217H49.4268V64.5743H49.5154V45.2217Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6035 45.2217H49.5149V64.5743H49.6035V45.2217Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6926 45.2217H49.604V64.5743H49.6926V45.2217Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78 45.2217H49.6914V64.5743H49.78V45.2217Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8687 45.2217H49.78V64.5743H49.8687V45.2217Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9573 45.2217H49.8687V64.5743H49.9573V45.2217Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0452 45.2217H49.9565V64.5743H50.0452V45.2217Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1331 45.2217H50.0444V64.5743H50.1331V45.2217Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2222 45.2217H50.1335V64.5743H50.2222V45.2217Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3108 45.2217H50.2222V64.5743H50.3108V45.2217Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.398 45.2217H50.3093V64.5743H50.398V45.2217Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4868 45.2217H50.3982V64.5743H50.4868V45.2217Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5755 45.2217H50.4868V64.5743H50.5755V45.2217Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6641 45.2217H50.5754V64.5743H50.6641V45.2217Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7517 45.2217H50.6631V64.5743H50.7517V45.2217Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8406 45.2217H50.752V64.5743H50.8406V45.2217Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9292 45.2217H50.8406V64.5743H50.9292V45.2217Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0164 45.2217H50.9277V64.5743H51.0164V45.2217Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1052 45.2217H51.0166V64.5743H51.1052V45.2217Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1936 45.2217H51.105V64.5743H51.1936V45.2217Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2825 45.2217H51.1938V64.5743H51.2825V45.2217Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3701 45.2217H51.2815V64.5743H51.3701V45.2217Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4588 45.2217H51.3701V64.5743H51.4588V45.2217Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5476 45.2217H51.459V64.5743H51.5476V45.2217Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6358 45.2217H51.5471V64.5743H51.6358V45.2217Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7239 45.2217H51.6353V64.5743H51.7239V45.2217Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8123 45.2217H51.7236V64.5743H51.8123V45.2217Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9004 45.2217H51.8118V64.5743H51.9004V45.2217Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9881 45.2217H51.8994V64.5743H51.9881V45.2217Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0769 45.2217H51.9883V64.5743H52.0769V45.2217Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1655 45.2217H52.0769V64.5743H52.1655V45.2217Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2544 45.2217H52.1658V64.5743H52.2544V45.2217Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3421 45.2217H52.2534V64.5743H52.3421V45.2217Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4307 45.2217H52.342V64.5743H52.4307V45.2217Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5191 45.2217H52.4304V64.5743H52.5191V45.2217Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6079 45.2217H52.5193V64.5743H52.6079V45.2217Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6953 45.2217H52.6067V64.5743H52.6953V45.2217Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.784 45.2217H52.6953V64.5743H52.784V45.2217Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8728 45.2217H52.7842V64.5743H52.8728V45.2217Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9612 45.2217H52.8726V64.5743H52.9612V45.2217Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0488 45.2217H52.9602V64.5743H53.0488V45.2217Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1375 45.2217H53.0488V64.5743H53.1375V45.2217Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2266 45.2217H53.1379V64.5743H53.2266V45.2217Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.314 45.2217H53.2253V64.5743H53.314V45.2217Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4026 45.2217H53.314V64.5743H53.4026V45.2217Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.491 45.2217H53.4023V64.5743H53.491V45.2217Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5798 45.2217H53.4912V64.5743H53.5798V45.2217Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6673 45.2217H53.5786V64.5743H53.6673V45.2217Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7559 45.2217H53.6672V64.5743H53.7559V45.2217Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8447 45.2217H53.7561V64.5743H53.8447V45.2217Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9334 45.2217H53.8447V64.5743H53.9334V45.2217Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.021 45.2217H53.9324V64.5743H54.021V45.2217Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1099 45.2217H54.0212V64.5743H54.1099V45.2217Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1983 45.2217H54.1096V64.5743H54.1983V45.2217Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2861 45.2217H54.1975V64.5743H54.2861V45.2217Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3743 45.2217H54.2856V64.5743H54.3743V45.2217Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4629 45.2217H54.3743V64.5743H54.4629V45.2217Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5518 45.2217H54.4631V64.5743H54.5518V45.2217Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6392 45.2217H54.5505V64.5743H54.6392V45.2217Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.728 45.2217H54.6394V64.5743H54.728V45.2217Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8164 45.2217H54.7278V64.5743H54.8164V45.2217Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9048 45.2217H54.8162V64.5743H54.9048V45.2217Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9927 45.2217H54.9041V64.5743H54.9927V45.2217Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0816 45.2217H54.9929V64.5743H55.0816V45.2217Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1702 45.2217H55.0815V64.5743H55.1702V45.2217Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2576 45.2217H55.1689V64.5743H55.2576V45.2217Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.346 45.2217H55.2573V64.5743H55.346V45.2217Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4348 45.2217H55.3462V64.5743H55.4348V45.2217Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5235 45.2217H55.4348V64.5743H55.5235V45.2217Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6111 45.2217H55.5225V64.5743H55.6111V45.2217Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6995 45.2217H55.6108V64.5743H55.6995V45.2217Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7883 45.2217H55.6997V64.5743H55.7883V45.2217Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.877 45.2217H55.7883V64.5743H55.877V45.2217Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9644 45.2217H55.8757V64.5743H55.9644V45.2217Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.053 45.2217H55.9644V64.5743H56.053V45.2217Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1416 45.2217H56.053V64.5743H56.1416V45.2217Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2293 45.2217H56.1406V64.5743H56.2293V45.2217Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3179 45.2217H56.2292V64.5743H56.3179V45.2217Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4068 45.2217H56.3181V64.5743H56.4068V45.2217Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4954 45.2217H56.4067V64.5743H56.4954V45.2217Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.583 45.2217H56.4944V64.5743H56.583V45.2217Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6716 45.2217H56.583V64.5743H56.6716V45.2217Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7598 45.2217H56.6711V64.5743H56.7598V45.2217Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8484 45.2217H56.7598V64.5743H56.8484V45.2217Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9363 45.2217H56.8477V64.5743H56.9363V45.2217Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0252 45.2217H56.9365V64.5743H57.0252V45.2217Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1135 45.2217H57.0249V64.5743H57.1135V45.2217Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2019 45.2217H57.1133V64.5743H57.2019V45.2217Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2898 45.2217H57.2012V64.5743H57.2898V45.2217Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3784 45.2217H57.2898V64.5743H57.3784V45.2217Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4673 45.2217H57.3787V64.5743H57.4673V45.2217Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6051 45.2217H57.4658V64.5743H57.6051V45.2217Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7445 45.2217H57.6052V64.5743H57.7445V45.2217Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8839 45.2217H57.7446V64.5743H57.8839V45.2217Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0231 45.2217H57.8838V64.5743H58.0231V45.2217Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1613 45.2217H58.022V64.5743H58.1613V45.2217Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3009 45.2217H58.1616V64.5743H58.3009V45.2217Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4401 45.2217H58.3008V64.5743H58.4401V45.2217Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5797 45.2217H58.4404V64.5743H58.5797V45.2217Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7186 45.2217H58.5793V64.5743H58.7186V45.2217Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8568 45.2217H58.7175V64.5743H58.8568V45.2217Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9962 45.2217H58.8569V64.5743H58.9962V45.2217Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1354 45.2217H58.9961V64.5743H59.1354V45.2217Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2748 45.2217H59.1355V64.5743H59.2748V45.2217Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4127 45.2217H59.2734V64.5743H59.4127V45.2217Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5521 45.2217H59.4128V64.5743H59.5521V45.2217Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6918 45.2217H59.5525V64.5743H59.6918V45.2217Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8307 45.2217H59.6914V64.5743H59.8307V45.2217Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9689 45.2217H59.8296V64.5743H59.9689V45.2217Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1088 45.2217H59.9695V64.5743H60.1088V45.2217Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2477 45.2217H60.1084V64.5743H60.2477V45.2217Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3866 45.2217H60.2473V64.5743H60.3866V45.2217Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5265 45.2217H60.3872V64.5743H60.5265V45.2217Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6647 45.2217H60.5254V64.5743H60.6647V45.2217Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8038 45.2217H60.6646V64.5743H60.8038V45.2217Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9428 45.2217H60.8035V64.5743H60.9428V45.2217Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0824 45.2217H60.9431V64.5743H61.0824V45.2217Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2206 45.2217H61.0813V64.5743H61.2206V45.2217Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3602 45.2217H61.2209V64.5743H61.3602V45.2217Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4987 45.2217H61.3594V64.5743H61.4987V45.2217Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6386 45.2217H61.4993V64.5743H61.6386V45.2217Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.777 45.2217H61.6377V64.5743H61.777V45.2217Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9161 45.2217H61.7769V64.5743H61.9161V45.2217Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0553 45.2217H61.916V64.5743H62.0553V45.2217Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1947 45.2217H62.0554V64.5743H62.1947V45.2217Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3339 45.2217H62.1946V64.5743H62.3339V45.2217Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4721 45.2217H62.3328V64.5743H62.4721V45.2217Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6115 45.2217H62.4722V64.5743H62.6115V45.2217Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7506 45.2217H62.6113V64.5743H62.7506V45.2217Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8898 45.2217H62.7505V64.5743H62.8898V45.2217Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0282 45.2217H62.8889V64.5743H63.0282V45.2217Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1676 45.2217H63.0283V64.5743H63.1676V45.2217Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3068 45.2217H63.1675V64.5743H63.3068V45.2217Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4459 45.2217H63.3066V64.5743H63.4459V45.2217Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5844 45.2217H63.4451V64.5743H63.5844V45.2217Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7233 45.2217H63.584V64.5743H63.7233V45.2217Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8627 45.2217H63.7234V64.5743H63.8627V45.2217Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0018 45.2217H63.8625V64.5743H64.0018V45.2217Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.141 45.2217H64.0017V64.5743H64.141V45.2217Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2794 45.2217H64.1401V64.5743H64.2794V45.2217Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4188 45.2217H64.2795V64.5743H64.4188V45.2217Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.558 45.2217H64.4187V64.5743H64.558V45.2217Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6974 45.2217H64.5581V64.5743H64.6974V45.2217Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8356 45.2217H64.6963V64.5743H64.8356V45.2217Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9747 45.2217H64.8354V64.5743H64.9747V45.2217Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1144 45.2217H64.9751V64.5743H65.1144V45.2217Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2533 45.2217H65.114V64.5743H65.2533V45.2217Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3915 45.2217H65.2522V64.5743H65.3915V45.2217Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5311 45.2217H65.3918V64.5743H65.5311V45.2217Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6703 45.2217H65.531V64.5743H65.6703V45.2217Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8099 45.2217H65.6707V64.5743H65.8099V45.2217Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9489 45.2217H65.8096V64.5743H65.9489V45.2217Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.087 45.2217H65.9478V64.5743H66.087V45.2217Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2264 45.2217H66.0872V64.5743H66.2264V45.2217Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3659 45.2217H66.2266V64.5743H66.3659V45.2217Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.505 45.2217H66.3657V64.5743H66.505V45.2217Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.643 45.2217H66.5037V64.5743H66.643V45.2217Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7826 45.2217H66.6433V64.5743H66.7826V45.2217Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9218 45.2217H66.7825V64.5743H66.9218V45.2217Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0614 45.2217H66.9221V64.5743H67.0614V45.2217Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1991 45.2217H67.0598V64.5743H67.1991V45.2217Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3383 45.2217H67.199V64.5743H67.3383V45.2217Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4779 45.2217H67.3386V64.5743H67.4779V45.2217Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6173 45.2217H67.478V64.5743H67.6173V45.2217Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7562 45.2217H67.6169V64.5743H67.7562V45.2217Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8949 45.2217H67.7556V64.5743H67.8949V45.2217Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0338 45.2217H67.8945V64.5743H68.0338V45.2217Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9135 45.2217H68.0342V64.5743H69.9135V45.2217Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 47,
    width: 27,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.554 66.5393L45.459 66.4285C46.6968 65.3796 47.6464 65.2266 48.5645 65.0789C49.5047 64.928 50.3921 64.7845 51.5982 63.762C52.8043 62.7395 53.0914 61.8879 53.3942 60.9857C53.6907 60.1046 53.9967 59.1929 55.2334 58.1451C56.4723 57.0962 57.422 56.9432 58.34 56.7955C59.2802 56.6435 60.1687 56.5011 61.3748 55.4775C62.583 54.4539 62.87 53.6013 63.175 52.6981C63.4726 51.8159 63.7796 50.9042 65.0184 49.8543C66.2583 48.8043 67.208 48.6513 68.1271 48.5036C69.0673 48.3516 69.9569 48.2081 71.164 47.1846L71.259 47.2954C70.0191 48.3453 69.0694 48.4983 68.1503 48.6471C67.2101 48.799 66.3206 48.9426 65.1134 49.9661C63.9052 50.9897 63.6182 51.8423 63.3132 52.7456C63.0156 53.6277 62.7086 54.5394 61.4698 55.5894C60.2309 56.6382 59.2812 56.7912 58.3632 56.94C57.423 57.092 56.5345 57.2344 55.3284 58.2569C54.1223 59.2794 53.8353 60.131 53.5324 61.0332C53.2359 61.9143 52.9299 62.826 51.6932 63.8738C50.4554 64.9227 49.5057 65.0757 48.5877 65.2235C47.6475 65.3744 46.7601 65.5179 45.554 66.5404V66.5393Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0658 47.1846H45.4587V66.5383H50.0658V47.1846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1543 47.1846H50.0657V66.5383H50.1543V47.1846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2437 47.1846H50.155V66.5383H50.2437V47.1846Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3323 47.1846H50.2437V66.5383H50.3323V47.1846Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4199 47.1846H50.3313V66.5383H50.4199V47.1846Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5081 47.1846H50.4194V66.5383H50.5081V47.1846Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5965 47.1846H50.5078V66.5383H50.5965V47.1846Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6853 47.1846H50.5967V66.5383H50.6853V47.1846Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7727 47.1846H50.6841V66.5383H50.7727V47.1846Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8616 47.1846H50.7729V66.5383H50.8616V47.1846Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9505 47.1846H50.8618V66.5383H50.9505V47.1846Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0391 47.1846H50.9504V66.5383H51.0391V47.1846Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1267 47.1846H51.0381V66.5383H51.1267V47.1846Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2151 47.1846H51.1265V66.5383H51.2151V47.1846Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3037 47.1846H51.2151V66.5383H51.3037V47.1846Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3914 47.1846H51.3027V66.5383H51.3914V47.1846Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.48 47.1846H51.3914V66.5383H51.48V47.1846Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5686 47.1846H51.48V66.5383H51.5686V47.1846Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6572 47.1846H51.5686V66.5383H51.6572V47.1846Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7451 47.1846H51.6565V66.5383H51.7451V47.1846Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8333 47.1846H51.7446V66.5383H51.8333V47.1846Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9219 47.1846H51.8333V66.5383H51.9219V47.1846Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0108 47.1846H51.9221V66.5383H52.0108V47.1846Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0982 47.1846H52.0095V66.5383H52.0982V47.1846Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1865 47.1846H52.0979V66.5383H52.1865V47.1846Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2754 47.1846H52.1868V66.5383H52.2754V47.1846Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3631 47.1846H52.2744V66.5383H52.3631V47.1846Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4517 47.1846H52.363V66.5383H52.4517V47.1846Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5405 47.1846H52.4519V66.5383H52.5405V47.1846Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6292 47.1846H52.5405V66.5383H52.6292V47.1846Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7168 47.1846H52.6282V66.5383H52.7168V47.1846Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8054 47.1846H52.7168V66.5383H52.8054V47.1846Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8941 47.1846H52.8054V66.5383H52.8941V47.1846Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9827 47.1846H52.894V66.5383H52.9827V47.1846Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0703 47.1846H52.9817V66.5383H53.0703V47.1846Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1587 47.1846H53.0701V66.5383H53.1587V47.1846Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2473 47.1846H53.1587V66.5383H53.2473V47.1846Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3352 47.1846H53.2466V66.5383H53.3352V47.1846Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4238 47.1846H53.3352V66.5383H53.4238V47.1846Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5122 47.1846H53.4236V66.5383H53.5122V47.1846Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6011 47.1846H53.5125V66.5383H53.6011V47.1846Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6887 47.1846H53.6001V66.5383H53.6887V47.1846Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7766 47.1846H53.688V66.5383H53.7766V47.1846Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8655 47.1846H53.7769V66.5383H53.8655V47.1846Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9541 47.1846H53.8655V66.5383H53.9541V47.1846Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0418 47.1846H53.9531V66.5383H54.0418V47.1846Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1309 47.1846H54.0422V66.5383H54.1309V47.1846Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2193 47.1846H54.1306V66.5383H54.2193V47.1846Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3069 47.1846H54.2183V66.5383H54.3069V47.1846Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.395 47.1846H54.3064V66.5383H54.395V47.1846Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4844 47.1846H54.3958V66.5383H54.4844V47.1846Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5733 47.1846H54.4846V66.5383H54.5733V47.1846Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6604 47.1846H54.5718V66.5383H54.6604V47.1846Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7493 47.1846H54.6606V66.5383H54.7493V47.1846Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8377 47.1846H54.749V66.5383H54.8377V47.1846Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9263 47.1846H54.8376V66.5383H54.9263V47.1846Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0139 47.1846H54.9253V66.5383H55.0139V47.1846Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1028 47.1846H55.0142V66.5383H55.1028V47.1846Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1914 47.1846H55.1028V66.5383H55.1914V47.1846Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2788 47.1846H55.1902V66.5383H55.2788V47.1846Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3677 47.1846H55.2791V66.5383H55.3677V47.1846Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4561 47.1846H55.3674V66.5383H55.4561V47.1846Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5444 47.1846H55.4558V66.5383H55.5444V47.1846Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6321 47.1846H55.5435V66.5383H55.6321V47.1846Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7207 47.1846H55.6321V66.5383H55.7207V47.1846Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8096 47.1846H55.7209V66.5383H55.8096V47.1846Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8982 47.1846H55.8096V66.5383H55.8982V47.1846Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9859 47.1846H55.8972V66.5383H55.9859V47.1846Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0747 47.1846H55.9861V66.5383H56.0747V47.1846Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1629 47.1846H56.0742V66.5383H56.1629V47.1846Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.252 47.1846H56.1633V66.5383H56.252V47.1846Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3394 47.1846H56.2507V66.5383H56.3394V47.1846Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.428 47.1846H56.3394V66.5383H56.428V47.1846Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5169 47.1846H56.4282V66.5383H56.5169V47.1846Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6043 47.1846H56.5156V66.5383H56.6043V47.1846Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6929 47.1846H56.6042V66.5383H56.6929V47.1846Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7815 47.1846H56.6929V66.5383H56.7815V47.1846Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8704 47.1846H56.7817V66.5383H56.8704V47.1846Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9578 47.1846H56.8691V66.5383H56.9578V47.1846Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0464 47.1846H56.9578V66.5383H57.0464V47.1846Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1345 47.1846H57.0459V66.5383H57.1345V47.1846Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2232 47.1846H57.1345V66.5383H57.2232V47.1846Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3113 47.1846H57.2227V66.5383H57.3113V47.1846Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3997 47.1846H57.311V66.5383H57.3997V47.1846Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4883 47.1846H57.3997V66.5383H57.4883V47.1846Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5755 47.1846H57.4868V66.5383H57.5755V47.1846Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6643 47.1846H57.5757V66.5383H57.6643V47.1846Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7534 47.1846H57.6648V66.5383H57.7534V47.1846Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8416 47.1846H57.7529V66.5383H57.8416V47.1846Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9295 47.1846H57.8408V66.5383H57.9295V47.1846Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0181 47.1846H57.9294V66.5383H58.0181V47.1846Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1067 47.1846H58.0181V66.5383H58.1067V47.1846Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1953 47.1846H58.1067V66.5383H58.1953V47.1846Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.283 47.1846H58.1943V66.5383H58.283V47.1846Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3718 47.1846H58.2832V66.5383H58.3718V47.1846Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4602 47.1846H58.3716V66.5383H58.4602V47.1846Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5479 47.1846H58.4592V66.5383H58.5479V47.1846Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 47.1846H58.5476V66.5383H58.6362V47.1846Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7246 47.1846H58.636V66.5383H58.7246V47.1846Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8137 47.1846H58.7251V66.5383H58.8137V47.1846Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9523 47.1846H58.813V66.5383H58.9523V47.1846Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0909 47.1846H58.9517V66.5383H59.0909V47.1846Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2304 47.1846H59.0911V66.5383H59.2304V47.1846Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.37 47.1846H59.2307V66.5383H59.37V47.1846Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5082 47.1846H59.3689V66.5383H59.5082V47.1846Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6473 47.1846H59.5081V66.5383H59.6473V47.1846Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7865 47.1846H59.6472V66.5383H59.7865V47.1846Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9259 47.1846H59.7866V66.5383H59.9259V47.1846Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0656 47.1846H59.9263V66.5383H60.0656V47.1846Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2037 47.1846H60.0645V66.5383H60.2037V47.1846Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3427 47.1846H60.2034V66.5383H60.3427V47.1846Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4818 47.1846H60.3425V66.5383H60.4818V47.1846Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6217 47.1846H60.4824V66.5383H60.6217V47.1846Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7594 47.1846H60.6201V66.5383H60.7594V47.1846Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8983 47.1846H60.759V66.5383H60.8983V47.1846Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0382 47.1846H60.8989V66.5383H61.0382V47.1846Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1776 47.1846H61.0383V66.5383H61.1776V47.1846Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3158 47.1846H61.1765V66.5383H61.3158V47.1846Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.455 47.1846H61.3157V66.5383H61.455V47.1846Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5941 47.1846H61.4548V66.5383H61.5941V47.1846Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7335 47.1846H61.5942V66.5383H61.7335V47.1846Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8729 47.1846H61.7336V66.5383H61.8729V47.1846Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0109 47.1846H61.8716V66.5383H62.0109V47.1846Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1505 47.1846H62.0112V66.5383H62.1505V47.1846Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2897 47.1846H62.1504V66.5383H62.2897V47.1846Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4288 47.1846H62.2896V66.5383H62.4288V47.1846Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.567 47.1846H62.4277V66.5383H62.567V47.1846Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7067 47.1846H62.5674V66.5383H62.7067V47.1846Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8458 47.1846H62.7065V66.5383H62.8458V47.1846Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9847 47.1846H62.8455V66.5383H62.9847V47.1846Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1232 47.1846H62.9839V66.5383H63.1232V47.1846Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2626 47.1846H63.1233V66.5383H63.2626V47.1846Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4015 47.1846H63.2622V66.5383H63.4015V47.1846Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5411 47.1846H63.4019V66.5383H63.5411V47.1846Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6805 47.1846H63.5413V66.5383H63.6805V47.1846Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8185 47.1846H63.6792V66.5383H63.8185V47.1846Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9579 47.1846H63.8186V66.5383H63.9579V47.1846Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0973 47.1846H63.958V66.5383H64.0973V47.1846Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2367 47.1846H64.0974V66.5383H64.2367V47.1846Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3746 47.1846H64.2354V66.5383H64.3746V47.1846Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.514 47.1846H64.3748V66.5383H64.514V47.1846Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6534 47.1846H64.5142V66.5383H64.6534V47.1846Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7926 47.1846H64.6533V66.5383H64.7926V47.1846Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9308 47.1846H64.7915V66.5383H64.9308V47.1846Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0702 47.1846H64.9309V66.5383H65.0702V47.1846Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2094 47.1846H65.0701V66.5383H65.2094V47.1846Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3485 47.1846H65.2092V66.5383H65.3485V47.1846Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4882 47.1846H65.3489V66.5383H65.4882V47.1846Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6263 47.1846H65.4871V66.5383H65.6263V47.1846Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7655 47.1846H65.6262V66.5383H65.7655V47.1846Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9047 47.1846H65.7654V66.5383H65.9047V47.1846Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0438 47.1846H65.9045V66.5383H66.0438V47.1846Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1823 47.1846H66.043V66.5383H66.1823V47.1846Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3217 47.1846H66.1824V66.5383H66.3217V47.1846Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4606 47.1846H66.3213V66.5383H66.4606V47.1846Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6 47.1846H66.4607V66.5383H66.6V47.1846Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7387 47.1846H66.5994V66.5383H66.7387V47.1846Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8778 47.1846H66.7385V66.5383H66.8778V47.1846Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0165 47.1846H66.8772V66.5383H67.0165V47.1846Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1559 47.1846H67.0166V66.5383H67.1559V47.1846Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2951 47.1846H67.1558V66.5383H67.2951V47.1846Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4337 47.1846H67.2944V66.5383H67.4337V47.1846Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5729 47.1846H67.4336V66.5383H67.5729V47.1846Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.712 47.1846H67.5728V66.5383H67.712V47.1846Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8517 47.1846H67.7124V66.5383H67.8517V47.1846Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9899 47.1846H67.8506V66.5383H67.9899V47.1846Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1293 47.1846H67.99V66.5383H68.1293V47.1846Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2682 47.1846H68.1289V66.5383H68.2682V47.1846Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4078 47.1846H68.2686V66.5383H68.4078V47.1846Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.546 47.1846H68.4067V66.5383H68.546V47.1846Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6854 47.1846H68.5461V66.5383H68.6854V47.1846Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8246 47.1846H68.6853V66.5383H68.8246V47.1846Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9637 47.1846H68.8245V66.5383H68.9637V47.1846Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1034 47.1846H68.9641V66.5383H69.1034V47.1846Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2416 47.1846H69.1023V66.5383H69.2416V47.1846Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3807 47.1846H69.2415V66.5383H69.3807V47.1846Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2597 47.1846H69.3804V66.5383H71.2597V47.1846Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 49,
    width: 27,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9001 68.5013L46.8052 68.3905C48.0429 67.3416 48.9926 67.1886 49.9107 67.0409C50.8509 66.89 51.7383 66.7465 52.9444 65.724C54.1505 64.7025 54.4375 63.8499 54.7404 62.9477C55.0369 62.0666 55.3429 61.1549 56.5796 60.1071C57.8185 59.0582 58.7681 58.9052 59.6862 58.7564C60.6264 58.6045 61.5149 58.462 62.721 57.4395C63.9292 56.4159 64.2162 55.5633 64.5212 54.6601C64.8188 53.7779 65.1258 52.8662 66.3646 51.8163C67.6045 50.7663 68.5542 50.6133 69.4722 50.4645C70.4135 50.3126 71.302 50.1691 72.5092 49.1455L72.6041 49.2563C71.3642 50.3062 70.4146 50.4592 69.4965 50.607C68.5563 50.7589 67.6668 50.9024 66.4596 51.926C65.2514 52.9496 64.9644 53.8022 64.6594 54.7054C64.3618 55.5876 64.0548 56.4993 62.816 57.5492C61.5771 58.5981 60.6274 58.7511 59.7094 58.8989C58.7692 59.0508 57.8807 59.1933 56.6746 60.2168C55.4685 61.2383 55.1815 62.0909 54.8786 62.9931C54.5821 63.8742 54.2761 64.7859 53.0394 65.8337C51.8016 66.8826 50.8519 67.0356 49.9339 67.1833C48.9937 67.3342 48.1063 67.4778 46.9001 68.5003V68.5013Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4125 49.1494H46.8054V68.5021H51.4125V49.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5015 49.1494H51.4128V68.5021H51.5015V49.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5901 49.1494H51.5015V68.5021H51.5901V49.1494Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6775 49.1494H51.5889V68.5021H51.6775V49.1494Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7661 49.1494H51.6775V68.5021H51.7661V49.1494Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8548 49.1494H51.7661V68.5021H51.8548V49.1494Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9434 49.1494H51.8547V68.5021H51.9434V49.1494Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0313 49.1494H51.9426V68.5021H52.0313V49.1494Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1196 49.1494H52.031V68.5021H52.1196V49.1494Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2085 49.1494H52.1199V68.5021H52.2085V49.1494Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2971 49.1494H52.2085V68.5021H52.2971V49.1494Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3843 49.1494H52.2957V68.5021H52.3843V49.1494Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4736 49.1494H52.385V68.5021H52.4736V49.1494Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5623 49.1494H52.4736V68.5021H52.5623V49.1494Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6494 49.1494H52.5608V68.5021H52.6494V49.1494Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7383 49.1494H52.6497V68.5021H52.7383V49.1494Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8267 49.1494H52.738V68.5021H52.8267V49.1494Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9155 49.1494H52.8269V68.5021H52.9155V49.1494Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0029 49.1494H52.9143V68.5021H53.0029V49.1494Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0918 49.1494H53.0032V68.5021H53.0918V49.1494Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1804 49.1494H53.0918V68.5021H53.1804V49.1494Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2688 49.1494H53.1802V68.5021H53.2688V49.1494Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3567 49.1494H53.2681V68.5021H53.3567V49.1494Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4451 49.1494H53.3564V68.5021H53.4451V49.1494Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.534 49.1494H53.4453V68.5021H53.534V49.1494Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6214 49.1494H53.5327V68.5021H53.6214V49.1494Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.71 49.1494H53.6213V68.5021H53.71V49.1494Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7986 49.1494H53.71V68.5021H53.7986V49.1494Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8872 49.1494H53.7986V68.5021H53.8872V49.1494Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9746 49.1494H53.886V68.5021H53.9746V49.1494Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0632 49.1494H53.9746V68.5021H54.0632V49.1494Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1519 49.1494H54.0632V68.5021H54.1519V49.1494Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2407 49.1494H54.1521V68.5021H54.2407V49.1494Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3284 49.1494H54.2397V68.5021H54.3284V49.1494Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.417 49.1494H54.3284V68.5021H54.417V49.1494Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5054 49.1494H54.4167V68.5021H54.5054V49.1494Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5933 49.1494H54.5046V68.5021H54.5933V49.1494Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6819 49.1494H54.5933V68.5021H54.6819V49.1494Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7705 49.1494H54.6819V68.5021H54.7705V49.1494Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8591 49.1494H54.7705V68.5021H54.8591V49.1494Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9468 49.1494H54.8582V68.5021H54.9468V49.1494Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0354 49.1494H54.9468V68.5021H55.0354V49.1494Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1238 49.1494H55.0352V68.5021H55.1238V49.1494Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2117 49.1494H55.123V68.5021H55.2117V49.1494Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2998 49.1494H55.2112V68.5021H55.2998V49.1494Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3889 49.1494H55.3003V68.5021H55.3889V49.1494Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4773 49.1494H55.3887V68.5021H55.4773V49.1494Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5647 49.1494H55.4761V68.5021H55.5647V49.1494Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6536 49.1494H55.5649V68.5021H55.6536V49.1494Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7422 49.1494H55.6536V68.5021H55.7422V49.1494Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8308 49.1494H55.7422V68.5021H55.8308V49.1494Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9182 49.1494H55.8296V68.5021H55.9182V49.1494Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0071 49.1494H55.9185V68.5021H56.0071V49.1494Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0957 49.1494H56.0071V68.5021H56.0957V49.1494Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1829 49.1494H56.0942V68.5021H56.1829V49.1494Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2722 49.1494H56.1836V68.5021H56.2722V49.1494Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3609 49.1494H56.2722V68.5021H56.3609V49.1494Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4492 49.1494H56.3606V68.5021H56.4492V49.1494Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5364 49.1494H56.4478V68.5021H56.5364V49.1494Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6253 49.1494H56.5366V68.5021H56.6253V49.1494Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7141 49.1494H56.6255V68.5021H56.7141V49.1494Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.803 49.1494H56.7144V68.5021H56.803V49.1494Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8904 49.1494H56.8018V68.5021H56.8904V49.1494Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9793 49.1494H56.8906V68.5021H56.9793V49.1494Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0676 49.1494H56.979V68.5021H57.0676V49.1494Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.155 49.1494H57.0664V68.5021H57.155V49.1494Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2439 49.1494H57.1553V68.5021H57.2439V49.1494Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3323 49.1494H57.2437V68.5021H57.3323V49.1494Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4212 49.1494H57.3325V68.5021H57.4212V49.1494Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5088 49.1494H57.4202V68.5021H57.5088V49.1494Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5974 49.1494H57.5088V68.5021H57.5974V49.1494Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.686 49.1494H57.5974V68.5021H57.686V49.1494Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7747 49.1494H57.686V68.5021H57.7747V49.1494Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8623 49.1494H57.7737V68.5021H57.8623V49.1494Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9509 49.1494H57.8623V68.5021H57.9509V49.1494Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0398 49.1494H57.9512V68.5021H58.0398V49.1494Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1272 49.1494H58.0386V68.5021H58.1272V49.1494Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2158 49.1494H58.1272V68.5021H58.2158V49.1494Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3042 49.1494H58.2156V68.5021H58.3042V49.1494Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3931 49.1494H58.3044V68.5021H58.3931V49.1494Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4807 49.1494H58.3921V68.5021H58.4807V49.1494Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5694 49.1494H58.4807V68.5021H58.5694V49.1494Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.658 49.1494H58.5693V68.5021H58.658V49.1494Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7464 49.1494H58.6577V68.5021H58.7464V49.1494Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.834 49.1494H58.7454V68.5021H58.834V49.1494Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9224 49.1494H58.8337V68.5021H58.9224V49.1494Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0112 49.1494H58.9226V68.5021H59.0112V49.1494Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 49.1494H59.01V68.5021H59.0986V49.1494Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1875 49.1494H59.0989V68.5021H59.1875V49.1494Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2761 49.1494H59.1875V68.5021H59.2761V49.1494Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3648 49.1494H59.2761V68.5021H59.3648V49.1494Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4527 49.1494H59.364V68.5021H59.4527V49.1494Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5408 49.1494H59.4521V68.5021H59.5408V49.1494Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6299 49.1494H59.5413V68.5021H59.6299V49.1494Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7185 49.1494H59.6299V68.5021H59.7185V49.1494Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8059 49.1494H59.7173V68.5021H59.8059V49.1494Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8945 49.1494H59.8059V68.5021H59.8945V49.1494Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9829 49.1494H59.8943V68.5021H59.9829V49.1494Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0711 49.1494H59.9824V68.5021H60.0711V49.1494Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1594 49.1494H60.0708V68.5021H60.1594V49.1494Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2987 49.1494H60.1594V68.5021H60.2987V49.1494Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4379 49.1494H60.2986V68.5021H60.4379V49.1494Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5763 49.1494H60.437V68.5021H60.5763V49.1494Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7155 49.1494H60.5762V68.5021H60.7155V49.1494Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8551 49.1494H60.7158V68.5021H60.8551V49.1494Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.994 49.1494H60.8547V68.5021H60.994V49.1494Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1324 49.1494H60.9932V68.5021H61.1324V49.1494Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2716 49.1494H61.1323V68.5021H61.2716V49.1494Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.411 49.1494H61.2717V68.5021H61.411V49.1494Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5502 49.1494H61.4109V68.5021H61.5502V49.1494Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6893 49.1494H61.55V68.5021H61.6893V49.1494Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8278 49.1494H61.6885V68.5021H61.8278V49.1494Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9669 49.1494H61.8276V68.5021H61.9669V49.1494Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1063 49.1494H61.967V68.5021H62.1063V49.1494Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2452 49.1494H62.106V68.5021H62.2452V49.1494Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3837 49.1494H62.2444V68.5021H62.3837V49.1494Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5231 49.1494H62.3838V68.5021H62.5231V49.1494Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6622 49.1494H62.5229V68.5021H62.6622V49.1494Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8019 49.1494H62.6626V68.5021H62.8019V49.1494Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9398 49.1494H62.8005V68.5021H62.9398V49.1494Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.079 49.1494H62.9397V68.5021H63.079V49.1494Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2179 49.1494H63.0786V68.5021H63.2179V49.1494Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3583 49.1494H63.219V68.5021H63.3583V49.1494Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.496 49.1494H63.3567V68.5021H63.496V49.1494Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6349 49.1494H63.4956V68.5021H63.6349V49.1494Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7745 49.1494H63.6353V68.5021H63.7745V49.1494Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9139 49.1494H63.7747V68.5021H63.9139V49.1494Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0531 49.1494H63.9138V68.5021H64.0531V49.1494Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1913 49.1494H64.052V68.5021H64.1913V49.1494Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3304 49.1494H64.1912V68.5021H64.3304V49.1494Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4701 49.1494H64.3308V68.5021H64.4701V49.1494Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6093 49.1494H64.47V68.5021H64.6093V49.1494Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7472 49.1494H64.6079V68.5021H64.7472V49.1494Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8868 49.1494H64.7476V68.5021H64.8868V49.1494Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.026 49.1494H64.8867V68.5021H65.026V49.1494Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1654 49.1494H65.0261V68.5021H65.1654V49.1494Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3031 49.1494H65.1638V68.5021H65.3031V49.1494Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.443 49.1494H65.3037V68.5021H65.443V49.1494Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5822 49.1494H65.4429V68.5021H65.5822V49.1494Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7213 49.1494H65.582V68.5021H65.7213V49.1494Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8597 49.1494H65.7205V68.5021H65.8597V49.1494Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9987 49.1494H65.8594V68.5021H65.9987V49.1494Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1383 49.1494H65.999V68.5021H66.1383V49.1494Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2775 49.1494H66.1382V68.5021H66.2775V49.1494Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4157 49.1494H66.2764V68.5021H66.4157V49.1494Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5553 49.1494H66.416V68.5021H66.5553V49.1494Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6942 49.1494H66.5549V68.5021H66.6942V49.1494Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8334 49.1494H66.6941V68.5021H66.8334V49.1494Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9728 49.1494H66.8335V68.5021H66.9728V49.1494Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1112 49.1494H66.9719V68.5021H67.1112V49.1494Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2501 49.1494H67.1108V68.5021H67.2501V49.1494Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3898 49.1494H67.2505V68.5021H67.3898V49.1494Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5292 49.1494H67.3899V68.5021H67.5292V49.1494Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6676 49.1494H67.5283V68.5021H67.6676V49.1494Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.807 49.1494H67.6677V68.5021H67.807V49.1494Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9462 49.1494H67.8069V68.5021H67.9462V49.1494Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0851 49.1494H67.9458V68.5021H68.0851V49.1494Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2235 49.1494H68.0842V68.5021H68.2235V49.1494Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3629 49.1494H68.2236V68.5021H68.3629V49.1494Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5018 49.1494H68.3625V68.5021H68.5018V49.1494Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6415 49.1494H68.5022V68.5021H68.6415V49.1494Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7797 49.1494H68.6404V68.5021H68.7797V49.1494Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9188 49.1494H68.7795V68.5021H68.9188V49.1494Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0582 49.1494H68.9189V68.5021H69.0582V49.1494Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1972 49.1494H69.0579V68.5021H69.1972V49.1494Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3366 49.1494H69.1973V68.5021H69.3366V49.1494Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.475 49.1494H69.3357V68.5021H69.475V49.1494Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6141 49.1494H69.4749V68.5021H69.6141V49.1494Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7531 49.1494H69.6138V68.5021H69.7531V49.1494Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8927 49.1494H69.7534V68.5021H69.8927V49.1494Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0309 49.1494H69.8916V68.5021H70.0309V49.1494Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1701 49.1494H70.0308V68.5021H70.1701V49.1494Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3095 49.1494H70.1702V68.5021H70.3095V49.1494Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4489 49.1494H70.3096V68.5021H70.4489V49.1494Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5868 49.1494H70.4475V68.5021H70.5868V49.1494Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7264 49.1494H70.5872V68.5021H70.7264V49.1494Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6054 49.1494H70.7261V68.5021H72.6054V49.1494Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 51,
    width: 27,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0129 71.0129L46.918 70.9021C48.1557 69.8532 49.1054 69.7002 50.0235 69.5525C50.9637 69.4016 51.8511 69.2591 53.0572 68.2366C54.2633 67.2141 54.5503 66.3625 54.8532 65.4603C55.1497 64.5792 55.4557 63.6675 56.6924 62.6197C57.9312 61.5708 58.8809 61.4178 59.799 61.2701C60.7392 61.1181 61.6277 60.9757 62.8338 59.9521C64.042 58.9286 64.329 58.0759 64.634 57.1727C64.9315 56.2905 65.2386 55.3788 66.4774 54.3289C67.7173 53.2789 68.667 53.1259 69.585 52.9782C70.5252 52.8262 71.4148 52.6827 72.6219 51.6592L72.7169 51.77C71.477 52.8199 70.5273 52.9729 69.6093 53.1217C68.6681 53.2737 67.7796 53.4172 66.5724 54.4407C65.3642 55.4643 65.0772 56.3169 64.7722 57.2202C64.4746 58.1023 64.1676 59.014 62.9287 60.064C61.6899 61.1128 60.7402 61.2659 59.8222 61.4146C58.882 61.5666 57.9935 61.709 56.7874 62.7315C55.5813 63.7541 55.2943 64.6056 54.9914 65.5078C54.6949 66.3889 54.3889 67.3006 53.1522 68.3485C51.9144 69.3973 50.9647 69.5503 50.0467 69.6981C49.1065 69.849 48.219 69.9914 47.0129 71.0139V71.0129Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5258 51.6602H46.9187V71.0128H51.5258V51.6602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6131 51.6602H51.5244V71.0128H51.6131V51.6602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7019 51.6602H51.6133V71.0128H51.7019V51.6602Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7903 51.6602H51.7017V71.0128H51.7903V51.6602Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8797 51.6602H51.791V71.0128H51.8797V51.6602Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9668 51.6602H51.8782V71.0128H51.9668V51.6602Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0554 51.6602H51.9668V71.0128H52.0554V51.6602Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1445 51.6602H52.0559V71.0128H52.1445V51.6602Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2329 51.6602H52.1443V71.0128H52.2329V51.6602Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3208 51.6602H52.2322V71.0128H52.3208V51.6602Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4094 51.6602H52.3208V71.0128H52.4094V51.6602Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4978 51.6602H52.4092V71.0128H52.4978V51.6602Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5855 51.6602H52.4968V71.0128H52.5855V51.6602Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6741 51.6602H52.5854V71.0128H52.6741V51.6602Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7627 51.6602H52.6741V71.0128H52.7627V51.6602Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8513 51.6602H52.7627V71.0128H52.8513V51.6602Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9392 51.6602H52.8506V71.0128H52.9392V51.6602Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0274 51.6602H52.9387V71.0128H53.0274V51.6602Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1162 51.6602H53.0276V71.0128H53.1162V51.6602Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2048 51.6602H53.1162V71.0128H53.2048V51.6602Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2923 51.6602H53.2036V71.0128H53.2923V51.6602Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3811 51.6602H53.2925V71.0128H53.3811V51.6602Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4697 51.6602H53.3811V71.0128H53.4697V51.6602Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5574 51.6602H53.4688V71.0128H53.5574V51.6602Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6458 51.6602H53.5571V71.0128H53.6458V51.6602Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7346 51.6602H53.646V71.0128H53.7346V51.6602Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8233 51.6602H53.7346V71.0128H53.8233V51.6602Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9107 51.6602H53.822V71.0128H53.9107V51.6602Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9998 51.6602H53.9111V71.0128H53.9998V51.6602Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0879 51.6602H53.9993V71.0128H54.0879V51.6602Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1765 51.6602H54.0879V71.0128H54.1765V51.6602Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2642 51.6602H54.1755V71.0128H54.2642V51.6602Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.353 51.6602H54.2644V71.0128H54.353V51.6602Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4417 51.6602H54.353V71.0128H54.4417V51.6602Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5293 51.6602H54.4407V71.0128H54.5293V51.6602Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6172 51.6602H54.5286V71.0128H54.6172V51.6602Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 51.6602H54.6177V71.0128H54.7063V51.6602Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7949 51.6602H54.7063V71.0128H54.7949V51.6602Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8823 51.6602H54.7937V71.0128H54.8823V51.6602Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9707 51.6602H54.8821V71.0128H54.9707V51.6602Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0596 51.6602H54.9709V71.0128H55.0596V51.6602Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1472 51.6602H55.0586V71.0128H55.1472V51.6602Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2359 51.6602H55.1472V71.0128H55.2359V51.6602Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3247 51.6602H55.2361V71.0128H55.3247V51.6602Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4133 51.6602H55.3247V71.0128H55.4133V51.6602Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5007 51.6602H55.4121V71.0128H55.5007V51.6602Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5894 51.6602H55.5007V71.0128H55.5894V51.6602Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.678 51.6602H55.5894V71.0128H55.678V51.6602Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7669 51.6602H55.6782V71.0128H55.7669V51.6602Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8545 51.6602H55.7659V71.0128H55.8545V51.6602Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9431 51.6602H55.8545V71.0128H55.9431V51.6602Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0315 51.6602H55.9429V71.0128H56.0315V51.6602Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1194 51.6602H56.0308V71.0128H56.1194V51.6602Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.208 51.6602H56.1194V71.0128H56.208V51.6602Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2966 51.6602H56.208V71.0128H56.2966V51.6602Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3853 51.6602H56.2966V71.0128H56.3853V51.6602Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4724 51.6602H56.3838V71.0128H56.4724V51.6602Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5613 51.6602H56.4727V71.0128H56.5613V51.6602Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6497 51.6602H56.561V71.0128H56.6497V51.6602Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7385 51.6602H56.6499V71.0128H56.7385V51.6602Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8259 51.6602H56.7373V71.0128H56.8259V51.6602Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9151 51.6602H56.8264V71.0128H56.9151V51.6602Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0037 51.6602H56.915V71.0128H57.0037V51.6602Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0908 51.6602H57.0022V71.0128H57.0908V51.6602Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1799 51.6602H57.0913V71.0128H57.1799V51.6602Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2683 51.6602H57.1797V71.0128H57.2683V51.6602Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3569 51.6602H57.2683V71.0128H57.3569V51.6602Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4446 51.6602H57.356V71.0128H57.4446V51.6602Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5335 51.6602H57.4448V71.0128H57.5335V51.6602Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6221 51.6602H57.5334V71.0128H57.6221V51.6602Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7107 51.6602H57.6221V71.0128H57.7107V51.6602Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7986 51.6602H57.71V71.0128H57.7986V51.6602Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.887 51.6602H57.7983V71.0128H57.887V51.6602Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9751 51.6602H57.8865V71.0128H57.9751V51.6602Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.063 51.6602H57.9744V71.0128H58.063V51.6602Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1519 51.6602H58.0632V71.0128H58.1519V51.6602Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2402 51.6602H58.1516V71.0128H58.2402V51.6602Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3289 51.6602H58.2402V71.0128H58.3289V51.6602Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4163 51.6602H58.3276V71.0128H58.4163V51.6602Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5054 51.6602H58.4167V71.0128H58.5054V51.6602Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5938 51.6602H58.5051V71.0128H58.5938V51.6602Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6824 51.6602H58.5938V71.0128H58.6824V51.6602Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7698 51.6602H58.6812V71.0128H58.7698V51.6602Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8587 51.6602H58.77V71.0128H58.8587V51.6602Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9473 51.6602H58.8586V71.0128H58.9473V51.6602Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0347 51.6602H58.946V71.0128H59.0347V51.6602Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1238 51.6602H59.0352V71.0128H59.1238V51.6602Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2122 51.6602H59.1235V71.0128H59.2122V51.6602Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.301 51.6602H59.2124V71.0128H59.301V51.6602Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3884 51.6602H59.2998V71.0128H59.3884V51.6602Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4771 51.6602H59.3884V71.0128H59.4771V51.6602Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5659 51.6602H59.4773V71.0128H59.5659V51.6602Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6546 51.6602H59.5659V71.0128H59.6546V51.6602Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.742 51.6602H59.6533V71.0128H59.742V51.6602Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8303 51.6602H59.7417V71.0128H59.8303V51.6602Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9187 51.6602H59.8301V71.0128H59.9187V51.6602Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0069 51.6602H59.9182V71.0128H60.0069V51.6602Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0955 51.6602H60.0068V71.0128H60.0955V51.6602Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1841 51.6602H60.0955V71.0128H60.1841V51.6602Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2725 51.6602H60.1838V71.0128H60.2725V51.6602Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4108 51.6602H60.2715V71.0128H60.4108V51.6602Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5499 51.6602H60.4106V71.0128H60.5499V51.6602Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6896 51.6602H60.5503V71.0128H60.6896V51.6602Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8287 51.6602H60.6895V71.0128H60.8287V51.6602Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9669 51.6602H60.8276V71.0128H60.9669V51.6602Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1063 51.6602H60.967V71.0128H61.1063V51.6602Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2455 51.6602H61.1062V71.0128H61.2455V51.6602Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3849 51.6602H61.2456V71.0128H61.3849V51.6602Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5233 51.6602H61.384V71.0128H61.5233V51.6602Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.662 51.6602H61.5227V71.0128H61.662V51.6602Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8016 51.6602H61.6624V71.0128H61.8016V51.6602Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.941 51.6602H61.8018V71.0128H61.941V51.6602Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0792 51.6602H61.9399V71.0128H62.0792V51.6602Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2189 51.6602H62.0796V71.0128H62.2189V51.6602Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3576 51.6602H62.2183V71.0128H62.3576V51.6602Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4967 51.6602H62.3574V71.0128H62.4967V51.6602Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6361 51.6602H62.4968V71.0128H62.6361V51.6602Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7748 51.6602H62.6355V71.0128H62.7748V51.6602Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9135 51.6602H62.7742V71.0128H62.9135V51.6602Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0531 51.6602H62.9138V71.0128H63.0531V51.6602Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.192 51.6602H63.0527V71.0128H63.192V51.6602Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3307 51.6602H63.1914V71.0128H63.3307V51.6602Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4701 51.6602H63.3308V71.0128H63.4701V51.6602Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.609 51.6602H63.4697V71.0128H63.609V51.6602Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7489 51.6602H63.6096V71.0128H63.7489V51.6602Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8868 51.6602H63.7476V71.0128H63.8868V51.6602Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.026 51.6602H63.8867V71.0128H64.026V51.6602Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1649 51.6602H64.0256V71.0128H64.1649V51.6602Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3048 51.6602H64.1655V71.0128H64.3048V51.6602Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4428 51.6602H64.3035V71.0128H64.4428V51.6602Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5819 51.6602H64.4426V71.0128H64.5819V51.6602Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7216 51.6602H64.5823V71.0128H64.7216V51.6602Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8607 51.6602H64.7214V71.0128H64.8607V51.6602Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0001 51.6602H64.8608V71.0128H65.0001V51.6602Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1383 51.6602H64.999V71.0128H65.1383V51.6602Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2775 51.6602H65.1382V71.0128H65.2775V51.6602Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4169 51.6602H65.2776V71.0128H65.4169V51.6602Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.556 51.6602H65.4167V71.0128H65.556V51.6602Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6942 51.6602H65.5549V71.0128H65.6942V51.6602Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8339 51.6602H65.6946V71.0128H65.8339V51.6602Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9728 51.6602H65.8335V71.0128H65.9728V51.6602Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1119 51.6602H65.9727V71.0128H66.1119V51.6602Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2501 51.6602H66.1108V71.0128H66.2501V51.6602Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3898 51.6602H66.2505V71.0128H66.3898V51.6602Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5289 51.6602H66.3896V71.0128H66.5289V51.6602Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6683 51.6602H66.5291V71.0128H66.6683V51.6602Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8063 51.6602H66.667V71.0128H66.8063V51.6602Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9457 51.6602H66.8064V71.0128H66.9457V51.6602Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0848 51.6602H66.9456V71.0128H67.0848V51.6602Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2245 51.6602H67.0852V71.0128H67.2245V51.6602Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3634 51.6602H67.2241V71.0128H67.3634V51.6602Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5018 51.6602H67.3625V71.0128H67.5018V51.6602Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.641 51.6602H67.5017V71.0128H67.641V51.6602Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7806 51.6602H67.6414V71.0128H67.7806V51.6602Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9198 51.6602H67.7805V71.0128H67.9198V51.6602Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0577 51.6602H67.9185V71.0128H68.0577V51.6602Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1974 51.6602H68.0581V71.0128H68.1974V51.6602Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.337 51.6602H68.1978V71.0128H68.337V51.6602Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.476 51.6602H68.3367V71.0128H68.476V51.6602Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6137 51.6602H68.4744V71.0128H68.6137V51.6602Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7535 51.6602H68.6143V71.0128H68.7535V51.6602Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8927 51.6602H68.7534V71.0128H68.8927V51.6602Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0316 51.6602H68.8923V71.0128H69.0316V51.6602Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1701 51.6602H69.0308V71.0128H69.1701V51.6602Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3095 51.6602H69.1702V71.0128H69.3095V51.6602Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4489 51.6602H69.3096V71.0128H69.4489V51.6602Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.588 51.6602H69.4487V71.0128H69.588V51.6602Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7272 51.6602H69.5879V71.0128H69.7272V51.6602Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8654 51.6602H69.7261V71.0128H69.8654V51.6602Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.005 51.6602H69.8657V71.0128H70.005V51.6602Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1439 51.6602H70.0046V71.0128H70.1439V51.6602Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2833 51.6602H70.144V71.0128H70.2833V51.6602Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4215 51.6602H70.2822V71.0128H70.4215V51.6602Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5609 51.6602H70.4216V71.0128H70.5609V51.6602Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7003 51.6602H70.561V71.0128H70.7003V51.6602Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8392 51.6602H70.7V71.0128H70.8392V51.6602Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7177 51.6602H70.8384V71.0128H72.7177V51.6602Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 53,
    width: 27,
    height: 20
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3584 72.975L48.2634 72.8641C49.5012 71.8153 50.4509 71.6623 51.3689 71.5145C52.3091 71.3636 53.1966 71.2201 54.4027 70.1976C55.6088 69.1762 55.8958 68.3236 56.1986 67.4214C56.4952 66.5403 56.8012 65.6285 58.0379 64.5807C59.2767 63.5318 60.2264 63.3788 61.1444 63.23C62.0846 63.0781 62.9731 62.9356 64.1792 61.9131C65.3875 60.8896 65.6745 60.037 65.9794 59.1337C66.277 58.2515 66.5841 57.3398 67.8229 56.2899C69.0628 55.24 70.0125 55.0869 70.9316 54.9382C71.8717 54.7862 72.7613 54.6427 73.9685 53.6191L74.0634 53.7299C72.8236 54.7799 71.8739 54.9329 70.9548 55.0806C70.0146 55.2326 69.125 55.3761 67.9179 56.3996C66.7096 57.4232 66.4226 58.2758 66.1177 59.1791C65.8201 60.0612 65.513 60.9729 64.2742 62.0229C63.0354 63.0718 62.0857 63.2248 61.1676 63.3725C60.2275 63.5244 59.339 63.6669 58.1329 64.6905C56.9267 65.7119 56.6397 66.5645 56.3369 67.4667C56.0404 68.3478 55.7343 69.2595 54.4976 70.3074C53.2599 71.3562 52.3102 71.5093 51.3921 71.657C50.4519 71.8079 49.5645 71.9514 48.3584 72.9739V72.975Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8715 53.6221H48.2644V72.9747H52.8715V53.6221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9602 53.6221H52.8716V72.9747H52.9602V53.6221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0481 53.6221H52.9595V72.9747H53.0481V53.6221Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1365 53.6221H53.0479V72.9747H53.1365V53.6221Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2251 53.6221H53.1365V72.9747H53.2251V53.6221Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3137 53.6221H53.2251V72.9747H53.3137V53.6221Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4016 53.6221H53.313V72.9747H53.4016V53.6221Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49 53.6221H53.4014V72.9747H53.49V53.6221Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5786 53.6221H53.49V72.9747H53.5786V53.6221Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6675 53.6221H53.5789V72.9747H53.6675V53.6221Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7547 53.6221H53.666V72.9747H53.7547V53.6221Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.843 53.6221H53.7544V72.9747H53.843V53.6221Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9321 53.6221H53.8435V72.9747H53.9321V53.6221Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0195 53.6221H53.9309V72.9747H54.0195V53.6221Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1082 53.6221H54.0195V72.9747H54.1082V53.6221Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1973 53.6221H54.1086V72.9747H54.1973V53.6221Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2859 53.6221H54.1973V72.9747H54.2859V53.6221Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3733 53.6221H54.2847V72.9747H54.3733V53.6221Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4622 53.6221H54.3735V72.9747H54.4622V53.6221Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5508 53.6221H54.4622V72.9747H54.5508V53.6221Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6397 53.6221H54.551V72.9747H54.6397V53.6221Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7268 53.6221H54.6382V72.9747H54.7268V53.6221Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8157 53.6221H54.7271V72.9747H54.8157V53.6221Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9041 53.6221H54.8154V72.9747H54.9041V53.6221Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9917 53.6221H54.9031V72.9747H54.9917V53.6221Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0803 53.6221H54.9917V72.9747H55.0803V53.6221Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1692 53.6221H55.0806V72.9747H55.1692V53.6221Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2581 53.6221H55.1694V72.9747H55.2581V53.6221Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.345 53.6221H55.2563V72.9747H55.345V53.6221Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4336 53.6221H55.345V72.9747H55.4336V53.6221Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5222 53.6221H55.4336V72.9747H55.5222V53.6221Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6109 53.6221H55.5222V72.9747H55.6109V53.6221Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6985 53.6221H55.6099V72.9747H55.6985V53.6221Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7874 53.6221H55.6987V72.9747H55.7874V53.6221Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.876 53.6221H55.7874V72.9747H55.876V53.6221Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9636 53.6221H55.875V72.9747H55.9636V53.6221Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0523 53.6221H55.9636V72.9747H56.0523V53.6221Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1409 53.6221H56.0522V72.9747H56.1409V53.6221Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2295 53.6221H56.1409V72.9747H56.2295V53.6221Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3169 53.6221H56.2283V72.9747H56.3169V53.6221Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4058 53.6221H56.3171V72.9747H56.4058V53.6221Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4942 53.6221H56.4055V72.9747H56.4942V53.6221Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5828 53.6221H56.4941V72.9747H56.5828V53.6221Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6709 53.6221H56.5823V72.9747H56.6709V53.6221Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.759 53.6221H56.6704V72.9747H56.759V53.6221Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8477 53.6221H56.759V72.9747H56.8477V53.6221Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9353 53.6221H56.8467V72.9747H56.9353V53.6221Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0239 53.6221H56.9353V72.9747H57.0239V53.6221Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1126 53.6221H57.0239V72.9747H57.1126V53.6221Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2012 53.6221H57.1125V72.9747H57.2012V53.6221Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2886 53.6221H57.2V72.9747H57.2886V53.6221Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3772 53.6221H57.2886V72.9747H57.3772V53.6221Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4661 53.6221H57.3774V72.9747H57.4661V53.6221Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5547 53.6221H57.4661V72.9747H57.5547V53.6221Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6419 53.6221H57.5532V72.9747H57.6419V53.6221Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7312 53.6221H57.6426V72.9747H57.7312V53.6221Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8198 53.6221H57.7312V72.9747H57.8198V53.6221Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9085 53.6221H57.8198V72.9747H57.9085V53.6221Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9956 53.6221H57.907V72.9747H57.9956V53.6221Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0845 53.6221H57.9958V72.9747H58.0845V53.6221Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1736 53.6221H58.085V72.9747H58.1736V53.6221Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2608 53.6221H58.1721V72.9747H58.2608V53.6221Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3494 53.6221H58.2607V72.9747H58.3494V53.6221Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4378 53.6221H58.3491V72.9747H58.4378V53.6221Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5269 53.6221H58.4382V72.9747H58.5269V53.6221Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.614 53.6221H58.5254V72.9747H58.614V53.6221Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7024 53.6221H58.6138V72.9747H58.7024V53.6221Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7913 53.6221H58.7026V72.9747H58.7913V53.6221Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8801 53.6221H58.7915V72.9747H58.8801V53.6221Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9678 53.6221H58.8792V72.9747H58.9678V53.6221Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0564 53.6221H58.9678V72.9747H59.0564V53.6221Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1448 53.6221H59.0562V72.9747H59.1448V53.6221Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2327 53.6221H59.144V72.9747H59.2327V53.6221Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3213 53.6221H59.2327V72.9747H59.3213V53.6221Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4099 53.6221H59.3213V72.9747H59.4099V53.6221Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4988 53.6221H59.4102V72.9747H59.4988V53.6221Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5862 53.6221H59.4976V72.9747H59.5862V53.6221Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6748 53.6221H59.5862V72.9747H59.6748V53.6221Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7632 53.6221H59.6746V72.9747H59.7632V53.6221Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8521 53.6221H59.7634V72.9747H59.8521V53.6221Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9397 53.6221H59.8511V72.9747H59.9397V53.6221Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0283 53.6221H59.9397V72.9747H60.0283V53.6221Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1172 53.6221H60.0286V72.9747H60.1172V53.6221Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2044 53.6221H60.1157V72.9747H60.2044V53.6221Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.293 53.6221H60.2043V72.9747H60.293V53.6221Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3816 53.6221H60.293V72.9747H60.3816V53.6221Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4702 53.6221H60.3816V72.9747H60.4702V53.6221Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5576 53.6221H60.469V72.9747H60.5576V53.6221Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6465 53.6221H60.5579V72.9747H60.6465V53.6221Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7351 53.6221H60.6465V72.9747H60.7351V53.6221Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8237 53.6221H60.7351V72.9747H60.8237V53.6221Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9116 53.6221H60.823V72.9747H60.9116V53.6221Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9998 53.6221H60.9111V72.9747H60.9998V53.6221Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0889 53.6221H61.0002V72.9747H61.0889V53.6221Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.176 53.6221H61.0874V72.9747H61.176V53.6221Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2649 53.6221H61.1763V72.9747H61.2649V53.6221Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3538 53.6221H61.2651V72.9747H61.3538V53.6221Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4422 53.6221H61.3535V72.9747H61.4422V53.6221Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.53 53.6221H61.4414V72.9747H61.53V53.6221Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6184 53.6221H61.5298V72.9747H61.6184V53.6221Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7579 53.6221H61.6187V72.9747H61.7579V53.6221Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8971 53.6221H61.7578V72.9747H61.8971V53.6221Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0353 53.6221H61.896V72.9747H62.0353V53.6221Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1744 53.6221H62.0352V72.9747H62.1744V53.6221Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3141 53.6221H62.1748V72.9747H62.3141V53.6221Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4533 53.6221H62.314V72.9747H62.4533V53.6221Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5914 53.6221H62.4521V72.9747H62.5914V53.6221Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7308 53.6221H62.5916V72.9747H62.7308V53.6221Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87 53.6221H62.7307V72.9747H62.87V53.6221Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0089 53.6221H62.8696V72.9747H63.0089V53.6221Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1483 53.6221H63.009V72.9747H63.1483V53.6221Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2868 53.6221H63.1475V72.9747H63.2868V53.6221Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4259 53.6221H63.2866V72.9747H63.4259V53.6221Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5651 53.6221H63.4258V72.9747H63.5651V53.6221Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7042 53.6221H63.5649V72.9747H63.7042V53.6221Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8427 53.6221H63.7034V72.9747H63.8427V53.6221Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9821 53.6221H63.8428V72.9747H63.9821V53.6221Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1212 53.6221H63.9819V72.9747H64.1212V53.6221Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2609 53.6221H64.1216V72.9747H64.2609V53.6221Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3988 53.6221H64.2595V72.9747H64.3988V53.6221Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.538 53.6221H64.3987V72.9747H64.538V53.6221Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6771 53.6221H64.5378V72.9747H64.6771V53.6221Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8173 53.6221H64.678V72.9747H64.8173V53.6221Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9562 53.6221H64.8169V72.9747H64.9562V53.6221Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0939 53.6221H64.9546V72.9747H65.0939V53.6221Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2338 53.6221H65.0945V72.9747H65.2338V53.6221Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3729 53.6221H65.2336V72.9747H65.3729V53.6221Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5121 53.6221H65.3728V72.9747H65.5121V53.6221Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6503 53.6221H65.511V72.9747H65.6503V53.6221Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7894 53.6221H65.6501V72.9747H65.7894V53.6221Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9291 53.6221H65.7898V72.9747H65.9291V53.6221Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0682 53.6221H65.929V72.9747H66.0682V53.6221Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2064 53.6221H66.0671V72.9747H66.2064V53.6221Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3458 53.6221H66.2065V72.9747H66.3458V53.6221Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.485 53.6221H66.3457V72.9747H66.485V53.6221Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6242 53.6221H66.4849V72.9747H66.6242V53.6221Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7636 53.6221H66.6243V72.9747H66.7636V53.6221Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.902 53.6221H66.7627V72.9747H66.902V53.6221Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0414 53.6221H66.9021V72.9747H67.0414V53.6221Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1805 53.6221H67.0413V72.9747H67.1805V53.6221Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3195 53.6221H67.1802V72.9747H67.3195V53.6221Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4579 53.6221H67.3186V72.9747H67.4579V53.6221Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5968 53.6221H67.4575V72.9747H67.5968V53.6221Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7367 53.6221H67.5974V72.9747H67.7367V53.6221Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8756 53.6221H67.7363V72.9747H67.8756V53.6221Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0143 53.6221H67.875V72.9747H68.0143V53.6221Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1534 53.6221H68.0142V72.9747H68.1534V53.6221Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2929 53.6221H68.1536V72.9747H68.2929V53.6221Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.432 53.6221H68.2927V72.9747H68.432V53.6221Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5712 53.6221H68.4319V72.9747H68.5712V53.6221Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7098 53.6221H68.5706V72.9747H68.7098V53.6221Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.849 53.6221H68.7097V72.9747H68.849V53.6221Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9882 53.6221H68.8489V72.9747H68.9882V53.6221Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1271 53.6221H68.9878V72.9747H69.1271V53.6221Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.266 53.6221H69.1267V72.9747H69.266V53.6221Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4052 53.6221H69.2659V72.9747H69.4052V53.6221Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5441 53.6221H69.4048V72.9747H69.5441V53.6221Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.683 53.6221H69.5437V72.9747H69.683V53.6221Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8219 53.6221H69.6826V72.9747H69.8219V53.6221Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9611 53.6221H69.8218V72.9747H69.9611V53.6221Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1002 53.6221H69.9609V72.9747H70.1002V53.6221Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2396 53.6221H70.1003V72.9747H70.2396V53.6221Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3785 53.6221H70.2393V72.9747H70.3785V53.6221Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5172 53.6221H70.3779V72.9747H70.5172V53.6221Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6561 53.6221H70.5168V72.9747H70.6561V53.6221Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7955 53.6221H70.6562V72.9747H70.7955V53.6221Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9349 53.6221H70.7957V72.9747H70.9349V53.6221Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0731 53.6221H70.9338V72.9747H71.0731V53.6221Z",
    fill: "#BC57F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2123 53.6221H71.073V72.9747H71.2123V53.6221Z",
    fill: "#BC56F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3517 53.6221H71.2124V72.9747H71.3517V53.6221Z",
    fill: "#BB55F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4911 53.6221H71.3518V72.9747H71.4911V53.6221Z",
    fill: "#BB54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.629 53.6221H71.4897V72.9747H71.629V53.6221Z",
    fill: "#BA54F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7684 53.6221H71.6292V72.9747H71.7684V53.6221Z",
    fill: "#BA53F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9078 53.6221H71.7686V72.9747H71.9078V53.6221Z",
    fill: "#BA52F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.047 53.6221H71.9077V72.9747H72.047V53.6221Z",
    fill: "#B951F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1869 53.6221H72.0476V72.9747H72.1869V53.6221Z",
    fill: "#B950F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0644 53.6221H72.1851V72.9747H74.0644V53.6221Z",
    fill: "#B950F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 55,
    width: 27,
    height: 20
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7056 74.9387L49.6106 74.8279C50.8484 73.7791 51.7981 73.626 52.7161 73.4783C53.6563 73.3274 54.5437 73.1839 55.7498 72.1614C56.9559 71.1389 57.243 70.2874 57.5458 69.3851C57.8423 68.504 58.1483 67.5923 59.385 66.5445C60.6239 65.4956 61.5736 65.3426 62.4916 65.1949C63.4318 65.0429 64.3203 64.9005 65.5264 63.8769C66.7346 62.8534 67.0216 62.0007 67.3266 61.0975C67.6242 60.2153 67.9312 59.3036 69.1701 58.2537C70.4099 57.2037 71.3596 57.0507 72.2777 56.903C73.2189 56.7511 74.1074 56.6075 75.3146 55.584L75.4095 55.6948C74.1707 56.7447 73.22 56.8977 72.3019 57.0465C71.3607 57.1985 70.4722 57.342 69.265 58.3655C68.0568 59.3891 67.7698 60.2417 67.4648 61.145C67.1673 62.0271 66.8602 62.9388 65.6214 63.9888C64.3825 65.0377 63.4329 65.1907 62.5148 65.3394C61.5746 65.4914 60.6861 65.6339 59.48 66.6564C58.2739 67.6789 57.9869 68.5304 57.684 69.4326C57.3875 70.3137 57.0815 71.2254 55.8448 72.2733C54.607 73.3221 53.6573 73.4752 52.7393 73.6229C51.7991 73.7738 50.9117 73.9173 49.7056 74.9398V74.9387Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2186 55.585H49.6116V74.9387H54.2186V55.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3059 55.585H54.2173V74.9387H54.3059V55.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3943 55.585H54.3057V74.9387H54.3943V55.585Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4829 55.585H54.3943V74.9387H54.4829V55.585Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5715 55.585H54.4829V74.9387H54.5715V55.585Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6594 55.585H54.5708V74.9387H54.6594V55.585Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7478 55.585H54.6592V74.9387H54.7478V55.585Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8367 55.585H54.748V74.9387H54.8367V55.585Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9253 55.585H54.8367V74.9387H54.9253V55.585Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0127 55.585H54.9241V74.9387H55.0127V55.585Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1011 55.585H55.0125V74.9387H55.1011V55.585Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19 55.585H55.1013V74.9387H55.19V55.585Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2776 55.585H55.189V74.9387H55.2776V55.585Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3662 55.585H55.2776V74.9387H55.3662V55.585Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4551 55.585H55.3665V74.9387H55.4551V55.585Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.544 55.585H55.4553V74.9387H55.544V55.585Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6314 55.585H55.5427V74.9387H55.6314V55.585Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7197 55.585H55.6311V74.9387H55.7197V55.585Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8089 55.585H55.7202V74.9387H55.8089V55.585Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8975 55.585H55.8088V74.9387H55.8975V55.585Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9849 55.585H55.8962V74.9387H55.9849V55.585Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0737 55.585H55.9851V74.9387H56.0737V55.585Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1621 55.585H56.0735V74.9387H56.1621V55.585Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2498 55.585H56.1611V74.9387H56.2498V55.585Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3384 55.585H56.2498V74.9387H56.3384V55.585Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.427 55.585H56.3384V74.9387H56.427V55.585Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 55.585H56.427V74.9387H56.5156V55.585Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.603 55.585H56.5144V74.9387H56.603V55.585Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6917 55.585H56.603V74.9387H56.6917V55.585Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7805 55.585H56.6919V74.9387H56.7805V55.585Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8689 55.585H56.7803V74.9387H56.8689V55.585Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9568 55.585H56.8682V74.9387H56.9568V55.585Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0452 55.585H56.9565V74.9387H57.0452V55.585Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1338 55.585H57.0452V74.9387H57.1338V55.585Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2217 55.585H57.1331V74.9387H57.2217V55.585Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3103 55.585H57.2217V74.9387H57.3103V55.585Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3989 55.585H57.3103V74.9387H57.3989V55.585Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4871 55.585H57.3984V74.9387H57.4871V55.585Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5752 55.585H57.4866V74.9387H57.5752V55.585Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6636 55.585H57.575V74.9387H57.6636V55.585Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7522 55.585H57.6636V74.9387H57.7522V55.585Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8406 55.585H57.752V74.9387H57.8406V55.585Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9287 55.585H57.8401V74.9387H57.9287V55.585Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0169 55.585H57.9282V74.9387H58.0169V55.585Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1057 55.585H58.0171V74.9387H58.1057V55.585Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1931 55.585H58.1045V74.9387H58.1931V55.585Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2818 55.585H58.1931V74.9387H58.2818V55.585Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3704 55.585H58.2817V74.9387H58.3704V55.585Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.459 55.585H58.3704V74.9387H58.459V55.585Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5466 55.585H58.458V74.9387H58.5466V55.585Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6355 55.585H58.5469V74.9387H58.6355V55.585Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7241 55.585H58.6355V74.9387H58.7241V55.585Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8128 55.585H58.7241V74.9387H58.8128V55.585Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8999 55.585H58.8113V74.9387H58.8999V55.585Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.989 55.585H58.9004V74.9387H58.989V55.585Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0774 55.585H58.9888V74.9387H59.0774V55.585Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1651 55.585H59.0764V74.9387H59.1651V55.585Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2539 55.585H59.1653V74.9387H59.2539V55.585Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3423 55.585H59.2537V74.9387H59.3423V55.585Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4312 55.585H59.3425V74.9387H59.4312V55.585Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5186 55.585H59.4299V74.9387H59.5186V55.585Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6069 55.585H59.5183V74.9387H59.6069V55.585Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6958 55.585H59.6072V74.9387H59.6958V55.585Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7835 55.585H59.6948V74.9387H59.7835V55.585Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8718 55.585H59.7832V74.9387H59.8718V55.585Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9607 55.585H59.8721V74.9387H59.9607V55.585Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0491 55.585H59.9604V74.9387H60.0491V55.585Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1367 55.585H60.0481V74.9387H60.1367V55.585Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2256 55.585H60.137V74.9387H60.2256V55.585Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3142 55.585H60.2256V74.9387H60.3142V55.585Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4033 55.585H60.3147V74.9387H60.4033V55.585Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.491 55.585H60.4023V74.9387H60.491V55.585Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5796 55.585H60.491V74.9387H60.5796V55.585Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.668 55.585H60.5793V74.9387H60.668V55.585Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7551 55.585H60.6665V74.9387H60.7551V55.585Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.844 55.585H60.7554V74.9387H60.844V55.585Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9329 55.585H60.8442V74.9387H60.9329V55.585Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0215 55.585H60.9329V74.9387H61.0215V55.585Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1091 55.585H61.0205V74.9387H61.1091V55.585Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.198 55.585H61.1094V74.9387H61.198V55.585Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2861 55.585H61.1975V74.9387H61.2861V55.585Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3748 55.585H61.2861V74.9387H61.3748V55.585Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4622 55.585H61.3735V74.9387H61.4622V55.585Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.551 55.585H61.4624V74.9387H61.551V55.585Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6397 55.585H61.551V74.9387H61.6397V55.585Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7271 55.585H61.6384V74.9387H61.7271V55.585Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8159 55.585H61.7273V74.9387H61.8159V55.585Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9046 55.585H61.8159V74.9387H61.9046V55.585Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 55.585H61.9045V74.9387H61.9932V55.585Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0806 55.585H61.9919V74.9387H62.0806V55.585Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1697 55.585H62.0811V74.9387H62.1697V55.585Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2583 55.585H62.1697V74.9387H62.2583V55.585Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3465 55.585H62.2578V74.9387H62.3465V55.585Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4343 55.585H62.3457V74.9387H62.4343V55.585Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5227 55.585H62.4341V74.9387H62.5227V55.585Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6116 55.585H62.5229V74.9387H62.6116V55.585Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.699 55.585H62.6104V74.9387H62.699V55.585Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7879 55.585H62.6992V74.9387H62.7879V55.585Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8762 55.585H62.7876V74.9387H62.8762V55.585Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 55.585H62.8765V74.9387H62.9651V55.585Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1034 55.585H62.9641V74.9387H63.1034V55.585Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2426 55.585H63.1033V74.9387H63.2426V55.585Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.382 55.585H63.2427V74.9387H63.382V55.585Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5209 55.585H63.3816V74.9387H63.5209V55.585Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6593 55.585H63.52V74.9387H63.6593V55.585Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.799 55.585H63.6597V74.9387H63.799V55.585Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9381 55.585H63.7988V74.9387H63.9381V55.585Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0775 55.585H63.9382V74.9387H64.0775V55.585Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2157 55.585H64.0764V74.9387H64.2157V55.585Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3549 55.585H64.2156V74.9387H64.3549V55.585Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.494 55.585H64.3547V74.9387H64.494V55.585Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6334 55.585H64.4941V74.9387H64.6334V55.585Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7726 55.585H64.6333V74.9387H64.7726V55.585Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9108 55.585H64.7715V74.9387H64.9108V55.585Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0502 55.585H64.9109V74.9387H65.0502V55.585Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1893 55.585H65.05V74.9387H65.1893V55.585Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3285 55.585H65.1892V74.9387H65.3285V55.585Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4672 55.585H65.3279V74.9387H65.4672V55.585Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6063 55.585H65.467V74.9387H65.6063V55.585Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7455 55.585H65.6062V74.9387H65.7455V55.585Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8847 55.585H65.7454V74.9387H65.8847V55.585Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0231 55.585H65.8838V74.9387H66.0231V55.585Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1622 55.585H66.0229V74.9387H66.1622V55.585Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3014 55.585H66.1621V74.9387H66.3014V55.585Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4408 55.585H66.3015V74.9387H66.4408V55.585Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5792 55.585H66.4399V74.9387H66.5792V55.585Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7184 55.585H66.5791V74.9387H66.7184V55.585Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8573 55.585H66.718V74.9387H66.8573V55.585Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9972 55.585H66.8579V74.9387H66.9972V55.585Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1351 55.585H66.9958V74.9387H67.1351V55.585Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2743 55.585H67.135V74.9387H67.2743V55.585Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4135 55.585H67.2742V74.9387H67.4135V55.585Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5531 55.585H67.4138V74.9387H67.5531V55.585Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6925 55.585H67.5532V74.9387H67.6925V55.585Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8307 55.585H67.6914V74.9387H67.8307V55.585Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9699 55.585H67.8306V74.9387H67.9699V55.585Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.109 55.585H67.9697V74.9387H68.109V55.585Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2487 55.585H68.1094V74.9387H68.2487V55.585Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3866 55.585H68.2473V74.9387H68.3866V55.585Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5258 55.585H68.3865V74.9387H68.5258V55.585Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6652 55.585H68.5259V74.9387H68.6652V55.585Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8046 55.585H68.6653V74.9387H68.8046V55.585Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9428 55.585H68.8035V74.9387H68.9428V55.585Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0819 55.585H68.9426V74.9387H69.0819V55.585Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2213 55.585H69.082V74.9387H69.2213V55.585Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3605 55.585H69.2212V74.9387H69.3605V55.585Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4992 55.585H69.3599V74.9387H69.4992V55.585Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6381 55.585H69.4988V74.9387H69.6381V55.585Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7775 55.585H69.6382V74.9387H69.7775V55.585Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9169 55.585H69.7776V74.9387H69.9169V55.585Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.056 55.585H69.9167V74.9387H70.056V55.585Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.194 55.585H70.0547V74.9387H70.194V55.585Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3336 55.585H70.1943V74.9387H70.3336V55.585Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4733 55.585H70.334V74.9387H70.4733V55.585Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6124 55.585H70.4731V74.9387H70.6124V55.585Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7504 55.585H70.6111V74.9387H70.7504V55.585Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8895 55.585H70.7502V74.9387H70.8895V55.585Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0294 55.585H70.8901V74.9387H71.0294V55.585Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1686 55.585H71.0293V74.9387H71.1686V55.585Z",
    fill: "#C060F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3063 55.585H71.167V74.9387H71.3063V55.585Z",
    fill: "#BF5FF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4462 55.585H71.3069V74.9387H71.4462V55.585Z",
    fill: "#BF5EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5853 55.585H71.446V74.9387H71.5853V55.585Z",
    fill: "#BE5DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7245 55.585H71.5852V74.9387H71.7245V55.585Z",
    fill: "#BE5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8624 55.585H71.7231V74.9387H71.8624V55.585Z",
    fill: "#BE5BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0023 55.585H71.863V74.9387H72.0023V55.585Z",
    fill: "#BD5AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1412 55.585H72.002V74.9387H72.1412V55.585Z",
    fill: "#BD59F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2806 55.585H72.1414V74.9387H72.2806V55.585Z",
    fill: "#BC58F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4198 55.585H72.2805V74.9387H72.4198V55.585Z",
    fill: "#BC57F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 57,
    width: 27,
    height: 20
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0505 76.9007L50.9556 76.7899C52.1933 75.741 53.143 75.588 54.0611 75.4403C55.0013 75.2894 55.8898 75.1459 57.0959 74.1234C58.302 73.102 58.589 72.2493 58.8918 71.3471C59.1873 70.466 59.4944 69.5543 60.73 68.5065C61.9688 67.4576 62.9185 67.3046 63.8366 67.1558C64.7768 67.0039 65.6653 66.8614 66.8714 65.8389C68.0796 64.8153 68.3666 63.9627 68.6716 63.0595C68.9691 62.1773 69.2762 61.2656 70.515 60.2157C71.7549 59.1657 72.7046 59.0127 73.6237 58.8639C74.5639 58.712 75.4534 58.5695 76.6606 57.5449L76.7556 57.6557C75.5157 58.7057 74.566 58.8587 73.6469 59.0074C72.7067 59.1594 71.8172 59.3019 70.61 60.3265C69.4018 61.35 69.1148 62.2026 68.8098 63.1059C68.5122 63.9881 68.2052 64.8998 66.9663 65.9497C65.7275 66.9986 64.7778 67.1516 63.8598 67.2993C62.9196 67.4513 62.0311 67.5937 60.825 68.6173C59.6189 69.6387 59.3319 70.4914 59.029 71.3936C58.7336 72.2747 58.4265 73.1864 57.1908 74.2342C55.952 75.2831 55.0023 75.4361 54.0843 75.5838C53.1451 75.7347 52.2566 75.8782 51.0505 76.9007Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5634 57.5488H50.9563V76.9015H55.5634V57.5488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6524 57.5488H55.5637V76.9015H55.6524V57.5488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.74 57.5488H55.6514V76.9015H55.74V57.5488Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8284 57.5488H55.7397V76.9015H55.8284V57.5488Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9173 57.5488H55.8286V76.9015H55.9173V57.5488Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0056 57.5488H55.917V76.9015H56.0056V57.5488Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0933 57.5488H56.0046V76.9015H56.0933V57.5488Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1821 57.5488H56.0935V76.9015H56.1821V57.5488Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2705 57.5488H56.1819V76.9015H56.2705V57.5488Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3591 57.5488H56.2705V76.9015H56.3591V57.5488Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4465 57.5488H56.3579V76.9015H56.4465V57.5488Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5352 57.5488H56.4465V76.9015H56.5352V57.5488Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6243 57.5488H56.5356V76.9015H56.6243V57.5488Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7114 57.5488H56.6228V76.9015H56.7114V57.5488Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8001 57.5488H56.7114V76.9015H56.8001V57.5488Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8889 57.5488H56.8003V76.9015H56.8889V57.5488Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9776 57.5488H56.8889V76.9015H56.9776V57.5488Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0652 57.5488H56.9766V76.9015H57.0652V57.5488Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1538 57.5488H57.0652V76.9015H57.1538V57.5488Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 57.5488H57.1538V76.9015H57.2424V57.5488Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3313 57.5488H57.2427V76.9015H57.3313V57.5488Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4187 57.5488H57.3301V76.9015H57.4187V57.5488Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5073 57.5488H57.4187V76.9015H57.5073V57.5488Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5957 57.5488H57.5071V76.9015H57.5957V57.5488Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6836 57.5488H57.595V76.9015H57.6836V57.5488Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 57.5488H57.6836V76.9015H57.7722V57.5488Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8611 57.5488H57.7725V76.9015H57.8611V57.5488Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9497 57.5488H57.8611V76.9015H57.9497V57.5488Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0366 57.5488H57.948V76.9015H58.0366V57.5488Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.126 57.5488H58.0374V76.9015H58.126V57.5488Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2141 57.5488H58.1255V76.9015H58.2141V57.5488Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3032 57.5488H58.2146V76.9015H58.3032V57.5488Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3904 57.5488H58.3018V76.9015H58.3904V57.5488Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4793 57.5488H58.3906V76.9015H58.4793V57.5488Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5681 57.5488H58.4795V76.9015H58.5681V57.5488Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6555 57.5488H58.5669V76.9015H58.6555V57.5488Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7444 57.5488H58.6558V76.9015H58.7444V57.5488Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8328 57.5488H58.7441V76.9015H58.8328V57.5488Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9216 57.5488H58.833V76.9015H58.9216V57.5488Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0088 57.5488H58.9202V76.9015H59.0088V57.5488Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0977 57.5488H59.009V76.9015H59.0977V57.5488Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1865 57.5488H59.0979V76.9015H59.1865V57.5488Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2749 57.5488H59.1863V76.9015H59.2749V57.5488Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3626 57.5488H59.2739V76.9015H59.3626V57.5488Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4507 57.5488H59.3621V76.9015H59.4507V57.5488Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5396 57.5488H59.4509V76.9015H59.5396V57.5488Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6282 57.5488H59.5396V76.9015H59.6282V57.5488Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7156 57.5488H59.627V76.9015H59.7156V57.5488Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8045 57.5488H59.7158V76.9015H59.8045V57.5488Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8931 57.5488H59.8044V76.9015H59.8931V57.5488Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9805 57.5488H59.8918V76.9015H59.9805V57.5488Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0691 57.5488H59.9805V76.9015H60.0691V57.5488Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.158 57.5488H60.0693V76.9015H60.158V57.5488Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2466 57.5488H60.158V76.9015H60.2466V57.5488Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3342 57.5488H60.2456V76.9015H60.3342V57.5488Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4231 57.5488H60.3345V76.9015H60.4231V57.5488Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5117 57.5488H60.4231V76.9015H60.5117V57.5488Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6004 57.5488H60.5117V76.9015H60.6004V57.5488Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6878 57.5488H60.5991V76.9015H60.6878V57.5488Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7764 57.5488H60.6877V76.9015H60.7764V57.5488Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.865 57.5488H60.7764V76.9015H60.865V57.5488Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9529 57.5488H60.8643V76.9015H60.9529V57.5488Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0413 57.5488H60.9526V76.9015H61.0413V57.5488Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1299 57.5488H61.0413V76.9015H61.1299V57.5488Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2185 57.5488H61.1299V76.9015H61.2185V57.5488Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3062 57.5488H61.2175V76.9015H61.3062V57.5488Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3945 57.5488H61.3059V76.9015H61.3945V57.5488Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4832 57.5488H61.3945V76.9015H61.4832V57.5488Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5718 57.5488H61.4832V76.9015H61.5718V57.5488Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6597 57.5488H61.571V76.9015H61.6597V57.5488Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7483 57.5488H61.6597V76.9015H61.7483V57.5488Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8367 57.5488H61.748V76.9015H61.8367V57.5488Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9248 57.5488H61.8362V76.9015H61.9248V57.5488Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0132 57.5488H61.9246V76.9015H62.0132V57.5488Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1018 57.5488H62.0132V76.9015H62.1018V57.5488Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1904 57.5488H62.1018V76.9015H62.1904V57.5488Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2781 57.5488H62.1895V76.9015H62.2781V57.5488Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3667 57.5488H62.2781V76.9015H62.3667V57.5488Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4553 57.5488H62.3667V76.9015H62.4553V57.5488Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.544 57.5488H62.4553V76.9015H62.544V57.5488Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6314 57.5488H62.5427V76.9015H62.6314V57.5488Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 57.5488H62.6313V76.9015H62.72V57.5488Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8089 57.5488H62.7202V76.9015H62.8089V57.5488Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8967 57.5488H62.8081V76.9015H62.8967V57.5488Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9849 57.5488H62.8962V76.9015H62.9849V57.5488Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0733 57.5488H62.9846V76.9015H63.0733V57.5488Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1621 57.5488H63.0735V76.9015H63.1621V57.5488Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2495 57.5488H63.1609V76.9015H63.2495V57.5488Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3384 57.5488H63.2498V76.9015H63.3384V57.5488Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4273 57.5488H63.3386V76.9015H63.4273V57.5488Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5156 57.5488H63.427V76.9015H63.5156V57.5488Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6035 57.5488H63.5149V76.9015H63.6035V57.5488Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6919 57.5488H63.6033V76.9015H63.6919V57.5488Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7808 57.5488H63.6921V76.9015H63.7808V57.5488Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8679 57.5488H63.7793V76.9015H63.8679V57.5488Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9568 57.5488H63.8682V76.9015H63.9568V57.5488Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0457 57.5488H63.957V76.9015H64.0457V57.5488Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.134 57.5488H64.0454V76.9015H64.134V57.5488Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2217 57.5488H64.1331V76.9015H64.2217V57.5488Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3103 57.5488H64.2217V76.9015H64.3103V57.5488Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4498 57.5488H64.3105V76.9015H64.4498V57.5488Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5885 57.5488H64.4492V76.9015H64.5885V57.5488Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7264 57.5488H64.5872V76.9015H64.7264V57.5488Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8666 57.5488H64.7273V76.9015H64.8666V57.5488Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0057 57.5488H64.8665V76.9015H65.0057V57.5488Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1449 57.5488H65.0056V76.9015H65.1449V57.5488Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2836 57.5488H65.1443V76.9015H65.2836V57.5488Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4225 57.5488H65.2832V76.9015H65.4225V57.5488Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5619 57.5488H65.4226V76.9015H65.5619V57.5488Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7013 57.5488H65.562V76.9015H65.7013V57.5488Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8402 57.5488H65.7009V76.9015H65.8402V57.5488Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9789 57.5488H65.8396V76.9015H65.9789V57.5488Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1178 57.5488H65.9785V76.9015H66.1178V57.5488Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2572 57.5488H66.1179V76.9015H66.2572V57.5488Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3964 57.5488H66.2571V76.9015H66.3964V57.5488Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5348 57.5488H66.3955V76.9015H66.5348V57.5488Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6737 57.5488H66.5344V76.9015H66.6737V57.5488Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8134 57.5488H66.6741V76.9015H66.8134V57.5488Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9528 57.5488H66.8135V76.9015H66.9528V57.5488Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0905 57.5488H66.9512V76.9015H67.0905V57.5488Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2299 57.5488H67.0906V76.9015H67.2299V57.5488Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3695 57.5488H67.2302V76.9015H67.3695V57.5488Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5087 57.5488H67.3694V76.9015H67.5087V57.5488Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6483 57.5488H67.509V76.9015H67.6483V57.5488Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7863 57.5488H67.647V76.9015H67.7863V57.5488Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9254 57.5488H67.7861V76.9015H67.9254V57.5488Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0648 57.5488H67.9255V76.9015H68.0648V57.5488Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2042 57.5488H68.0649V76.9015H68.2042V57.5488Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3422 57.5488H68.2029V76.9015H68.3422V57.5488Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4813 57.5488H68.342V76.9015H68.4813V57.5488Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 57.5488H68.4814V76.9015H68.6207V57.5488Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7604 57.5488H68.6211V76.9015H68.7604V57.5488Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8986 57.5488H68.7593V76.9015H68.8986V57.5488Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0377 57.5488H68.8984V76.9015H69.0377V57.5488Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1771 57.5488H69.0378V76.9015H69.1771V57.5488Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3163 57.5488H69.177V76.9015H69.3163V57.5488Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4555 57.5488H69.3162V76.9015H69.4555V57.5488Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5939 57.5488H69.4546V76.9015H69.5939V57.5488Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.733 57.5488H69.5938V76.9015H69.733V57.5488Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8722 57.5488H69.7329V76.9015H69.8722V57.5488Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0116 57.5488H69.8723V76.9015H70.0116V57.5488Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15 57.5488H70.0107V76.9015H70.15V57.5488Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2892 57.5488H70.1499V76.9015H70.2892V57.5488Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4284 57.5488H70.2891V76.9015H70.4284V57.5488Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5678 57.5488H70.4285V76.9015H70.5678V57.5488Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7062 57.5488H70.5669V76.9015H70.7062V57.5488Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8451 57.5488H70.7058V76.9015H70.8451V57.5488Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9843 57.5488H70.845V76.9015H70.9843V57.5488Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1237 57.5488H70.9844V76.9015H71.1237V57.5488Z",
    fill: "#C46AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 57.5488H71.1238V76.9015H71.2631V57.5488Z",
    fill: "#C369F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4017 57.5488H71.2625V76.9015H71.4017V57.5488Z",
    fill: "#C368F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5404 57.5488H71.4011V76.9015H71.5404V57.5488Z",
    fill: "#C267F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6801 57.5488H71.5408V76.9015H71.6801V57.5488Z",
    fill: "#C266F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8192 57.5488H71.6799V76.9015H71.8192V57.5488Z",
    fill: "#C265F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9576 57.5488H71.8184V76.9015H71.9576V57.5488Z",
    fill: "#C164F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0968 57.5488H71.9575V76.9015H72.0968V57.5488Z",
    fill: "#C163F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.236 57.5488H72.0967V76.9015H72.236V57.5488Z",
    fill: "#C062F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3751 57.5488H72.2358V76.9015H72.3751V57.5488Z",
    fill: "#C061F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5138 57.5488H72.3745V76.9015H72.5138V57.5488Z",
    fill: "#C060F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2453_55060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 59,
    width: 27,
    height: 20
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3967 78.8644L52.3018 78.7536C53.5395 77.7048 54.4892 77.5518 55.4073 77.404C56.3475 77.2531 57.2349 77.1096 58.441 76.0871C59.6471 75.0646 59.9341 74.213 60.237 73.3108C60.5335 72.4297 60.8395 71.518 62.0762 70.4702C63.315 69.4213 64.2647 69.2683 65.1828 69.1206C66.123 68.9686 67.0115 68.8262 68.2176 67.8037C69.4258 66.7801 69.7128 65.9275 70.0178 65.0242C70.3153 64.1421 70.6224 63.2304 71.8612 62.1804C73.1011 61.1305 74.0508 60.9775 74.9699 60.8298C75.9101 60.6778 76.7986 60.5343 78.0057 59.5107L78.1007 59.6215C76.8619 60.6715 75.9111 60.8245 74.9931 60.9722C74.0529 61.1242 73.1634 61.2677 71.9562 62.2912C70.748 63.3148 70.461 64.1674 70.156 65.0707C69.8584 65.9528 69.5514 66.8645 68.3125 67.9145C67.0737 68.9634 66.124 69.1164 65.206 69.2641C64.2658 69.416 63.3773 69.5585 62.1712 70.581C60.9651 71.6035 60.6781 72.4551 60.3752 73.3573C60.0787 74.2384 59.7727 75.1501 58.536 76.1979C57.2982 77.2468 56.3485 77.3998 55.4305 77.5475C54.4903 77.6984 53.6028 77.8419 52.3967 78.8644Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2453_55060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9105 59.5107H52.3035V78.8634H56.9105V59.5107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9988 59.5098H56.9102V78.8624H56.9988V59.5098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0862 59.5098H56.9976V78.8624H57.0862V59.5098Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1753 59.5098H57.0867V78.8624H57.1753V59.5098Z",
    fill: "#FEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2639 59.5098H57.1753V78.8624H57.2639V59.5098Z",
    fill: "#FEFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3516 59.5098H57.2629V78.8624H57.3516V59.5098Z",
    fill: "#FDFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4397 59.5098H57.3511V78.8624H57.4397V59.5098Z",
    fill: "#FDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5283 59.5098H57.4397V78.8624H57.5283V59.5098Z",
    fill: "#FDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6174 59.5098H57.5288V78.8624H57.6174V59.5098Z",
    fill: "#FCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7046 59.5098H57.616V78.8624H57.7046V59.5098Z",
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7932 59.5098H57.7046V78.8624H57.7932V59.5098Z",
    fill: "#FBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8821 59.5098H57.7935V78.8624H57.8821V59.5098Z",
    fill: "#FBF5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9697 59.5098H57.8811V78.8624H57.9697V59.5098Z",
    fill: "#FBF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0584 59.5098H57.9697V78.8624H58.0584V59.5098Z",
    fill: "#FAF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.147 59.5098H58.0583V78.8624H58.147V59.5098Z",
    fill: "#FAF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2356 59.5098H58.147V78.8624H58.2356V59.5098Z",
    fill: "#F9F1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.323 59.5098H58.2344V78.8624H58.323V59.5098Z",
    fill: "#F9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4116 59.5098H58.323V78.8624H58.4116V59.5098Z",
    fill: "#F9EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5005 59.5098H58.4119V78.8624H58.5005V59.5098Z",
    fill: "#F8EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5889 59.5098H58.5002V78.8624H58.5889V59.5098Z",
    fill: "#F8EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6768 59.5098H58.5881V78.8624H58.6768V59.5098Z",
    fill: "#F7ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7649 59.5098H58.6763V78.8624H58.7649V59.5098Z",
    fill: "#F7EBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8538 59.5098H58.7651V78.8624H58.8538V59.5098Z",
    fill: "#F7EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9414 59.5098H58.8528V78.8624H58.9414V59.5098Z",
    fill: "#F6E9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.03 59.5098H58.9414V78.8624H59.03V59.5098Z",
    fill: "#F6E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1192 59.5098H59.0305V78.8624H59.1192V59.5098Z",
    fill: "#F5E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2073 59.5098H59.1187V78.8624H59.2073V59.5098Z",
    fill: "#F5E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2949 59.5098H59.2063V78.8624H59.2949V59.5098Z",
    fill: "#F5E5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3836 59.5098H59.2949V78.8624H59.3836V59.5098Z",
    fill: "#F4E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4722 59.5098H59.3835V78.8624H59.4722V59.5098Z",
    fill: "#F4E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5608 59.5098H59.4722V78.8624H59.5608V59.5098Z",
    fill: "#F3E2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6485 59.5098H59.5598V78.8624H59.6485V59.5098Z",
    fill: "#F3E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7371 59.5098H59.6484V78.8624H59.7371V59.5098Z",
    fill: "#F3E0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8257 59.5098H59.7371V78.8624H59.8257V59.5098Z",
    fill: "#F2DEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9133 59.5098H59.8247V78.8624H59.9133V59.5098Z",
    fill: "#F2DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.002 59.5098H59.9133V78.8624H60.002V59.5098Z",
    fill: "#F1DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0906 59.5098H60.002V78.8624H60.0906V59.5098Z",
    fill: "#F1DBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1792 59.5098H60.0906V78.8624H60.1792V59.5098Z",
    fill: "#F1DAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2669 59.5098H60.1782V78.8624H60.2669V59.5098Z",
    fill: "#F0D9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3555 59.5098H60.2668V78.8624H60.3555V59.5098Z",
    fill: "#F0D8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4441 59.5098H60.3555V78.8624H60.4441V59.5098Z",
    fill: "#EFD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5327 59.5098H60.4441V78.8624H60.5327V59.5098Z",
    fill: "#EFD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6199 59.5098H60.5312V78.8624H60.6199V59.5098Z",
    fill: "#EFD5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7085 59.5098H60.6199V78.8624H60.7085V59.5098Z",
    fill: "#EED4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7974 59.5098H60.7087V78.8624H60.7974V59.5098Z",
    fill: "#EED3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.885 59.5098H60.7964V78.8624H60.885V59.5098Z",
    fill: "#EDD2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9739 59.5098H60.8853V78.8624H60.9739V59.5098Z",
    fill: "#EDD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0625 59.5098H60.9739V78.8624H61.0625V59.5098Z",
    fill: "#EDD0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1509 59.5098H61.0623V78.8624H61.1509V59.5098Z",
    fill: "#ECCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2388 59.5098H61.1501V78.8624H61.2388V59.5098Z",
    fill: "#ECCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3272 59.5098H61.2385V78.8624H61.3272V59.5098Z",
    fill: "#EBCDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4158 59.5098H61.3271V78.8624H61.4158V59.5098Z",
    fill: "#EBCCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5051 59.5098H61.4165V78.8624H61.5051V59.5098Z",
    fill: "#EBCBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5921 59.5098H61.5034V78.8624H61.5921V59.5098Z",
    fill: "#EACAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6807 59.5098H61.592V78.8624H61.6807V59.5098Z",
    fill: "#EAC9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7693 59.5098H61.6807V78.8624H61.7693V59.5098Z",
    fill: "#E9C8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8572 59.5098H61.7686V78.8624H61.8572V59.5098Z",
    fill: "#E9C7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9458 59.5098H61.8572V78.8624H61.9458V59.5098Z",
    fill: "#E9C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0344 59.5098H61.9458V78.8624H62.0344V59.5098Z",
    fill: "#E8C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1233 59.5098H62.0347V78.8624H62.1233V59.5098Z",
    fill: "#E8C4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2105 59.5098H62.1218V78.8624H62.2105V59.5098Z",
    fill: "#E7C3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2993 59.5098H62.2107V78.8624H62.2993V59.5098Z",
    fill: "#E7C2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3877 59.5098H62.2991V78.8624H62.3877V59.5098Z",
    fill: "#E7C1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4761 59.5098H62.3875V78.8624H62.4761V59.5098Z",
    fill: "#E6C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5637 59.5098H62.4751V78.8624H62.5637V59.5098Z",
    fill: "#E6BFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6526 59.5098H62.564V78.8624H62.6526V59.5098Z",
    fill: "#E5BEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7412 59.5098H62.6526V78.8624H62.7412V59.5098Z",
    fill: "#E5BDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8289 59.5098H62.7402V78.8624H62.8289V59.5098Z",
    fill: "#E5BCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9177 59.5098H62.8291V78.8624H62.9177V59.5098Z",
    fill: "#E4BBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0061 59.5098H62.9175V78.8624H63.0061V59.5098Z",
    fill: "#E4BAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0945 59.5098H63.0059V78.8624H63.0945V59.5098Z",
    fill: "#E3B9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1821 59.5098H63.0935V78.8624H63.1821V59.5098Z",
    fill: "#E3B8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.271 59.5098H63.1824V78.8624H63.271V59.5098Z",
    fill: "#E3B7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3596 59.5098H63.271V78.8624H63.3596V59.5098Z",
    fill: "#E2B6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4473 59.5098H63.3586V78.8624H63.4473V59.5098Z",
    fill: "#E2B5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5359 59.5098H63.4473V78.8624H63.5359V59.5098Z",
    fill: "#E1B4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6245 59.5098H63.5359V78.8624H63.6245V59.5098Z",
    fill: "#E1B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7131 59.5098H63.6245V78.8624H63.7131V59.5098Z",
    fill: "#E1B2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8006 59.5098H63.7119V78.8624H63.8006V59.5098Z",
    fill: "#E0B1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8894 59.5098H63.8008V78.8624H63.8894V59.5098Z",
    fill: "#E0B0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.978 59.5098H63.8894V78.8624H63.978V59.5098Z",
    fill: "#DFAFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0664 59.5098H63.9778V78.8624H64.0664V59.5098Z",
    fill: "#DFAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1543 59.5098H64.0657V78.8624H64.1543V59.5098Z",
    fill: "#DFADFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2429 59.5098H64.1543V78.8624H64.2429V59.5098Z",
    fill: "#DEACFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3313 59.5098H64.2427V78.8624H64.3313V59.5098Z",
    fill: "#DEABFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4192 59.5098H64.3306V78.8624H64.4192V59.5098Z",
    fill: "#DDAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5078 59.5098H64.4192V78.8624H64.5078V59.5098Z",
    fill: "#DDA9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5965 59.5098H64.5078V78.8624H64.5965V59.5098Z",
    fill: "#DDA8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6853 59.5098H64.5967V78.8624H64.6853V59.5098Z",
    fill: "#DCA7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7725 59.5098H64.6838V78.8624H64.7725V59.5098Z",
    fill: "#DCA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8613 59.5098H64.7727V78.8624H64.8613V59.5098Z",
    fill: "#DCA5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9495 59.5098H64.8608V78.8624H64.9495V59.5098Z",
    fill: "#DBA4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0383 59.5098H64.9497V78.8624H65.0383V59.5098Z",
    fill: "#DBA3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.126 59.5098H65.0374V78.8624H65.126V59.5098Z",
    fill: "#DAA2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2146 59.5098H65.126V78.8624H65.2146V59.5098Z",
    fill: "#DAA1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3035 59.5098H65.2148V78.8624H65.3035V59.5098Z",
    fill: "#DAA0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3909 59.5098H65.3022V78.8624H65.3909V59.5098Z",
    fill: "#D99FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4795 59.5098H65.3909V78.8624H65.4795V59.5098Z",
    fill: "#D99EF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5679 59.5098H65.4792V78.8624H65.5679V59.5098Z",
    fill: "#D89DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6568 59.5098H65.5681V78.8624H65.6568V59.5098Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7948 59.5098H65.6555V78.8624H65.7948V59.5098Z",
    fill: "#D89CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9345 59.5098H65.7952V78.8624H65.9345V59.5098Z",
    fill: "#D89BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0736 59.5098H65.9343V78.8624H66.0736V59.5098Z",
    fill: "#D79AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.213 59.5098H66.0737V78.8624H66.213V59.5098Z",
    fill: "#D799F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3512 59.5098H66.2119V78.8624H66.3512V59.5098Z",
    fill: "#D698F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4901 59.5098H66.3508V78.8624H66.4901V59.5098Z",
    fill: "#D697F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6295 59.5098H66.4902V78.8624H66.6295V59.5098Z",
    fill: "#D596F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7694 59.5098H66.6301V78.8624H66.7694V59.5098Z",
    fill: "#D595F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9074 59.5098H66.7681V78.8624H66.9074V59.5098Z",
    fill: "#D594F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0463 59.5098H66.907V78.8624H67.0463V59.5098Z",
    fill: "#D492F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1862 59.5098H67.0469V78.8624H67.1862V59.5098Z",
    fill: "#D491F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3253 59.5098H67.186V78.8624H67.3253V59.5098Z",
    fill: "#D390F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4647 59.5098H67.3254V78.8624H67.4647V59.5098Z",
    fill: "#D38FF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6027 59.5098H67.4634V78.8624H67.6027V59.5098Z",
    fill: "#D28EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7421 59.5098H67.6028V78.8624H67.7421V59.5098Z",
    fill: "#D28DF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8812 59.5098H67.7419V78.8624H67.8812V59.5098Z",
    fill: "#D28CF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0206 59.5098H67.8813V78.8624H68.0206V59.5098Z",
    fill: "#D18BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1588 59.5098H68.0195V78.8624H68.1588V59.5098Z",
    fill: "#D18AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.298 59.5098H68.1587V78.8624H68.298V59.5098Z",
    fill: "#D089F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4376 59.5098H68.2983V78.8624H68.4376V59.5098Z",
    fill: "#D088F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5768 59.5098H68.4375V78.8624H68.5768V59.5098Z",
    fill: "#CF87F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.715 59.5098H68.5757V78.8624H68.715V59.5098Z",
    fill: "#CF86F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8544 59.5098H68.7151V78.8624H68.8544V59.5098Z",
    fill: "#CF85F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9933 59.5098H68.854V78.8624H68.9933V59.5098Z",
    fill: "#CE84F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1329 59.5098H68.9937V78.8624H69.1329V59.5098Z",
    fill: "#CE83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2711 59.5098H69.1318V78.8624H69.2711V59.5098Z",
    fill: "#CD82F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4105 59.5098H69.2712V78.8624H69.4105V59.5098Z",
    fill: "#CD81F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5494 59.5098H69.4102V78.8624H69.5494V59.5098Z",
    fill: "#CC80F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6888 59.5098H69.5496V78.8624H69.6888V59.5098Z",
    fill: "#CC7FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.828 59.5098H69.6887V78.8624H69.828V59.5098Z",
    fill: "#CC7EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9664 59.5098H69.8271V78.8624H69.9664V59.5098Z",
    fill: "#CB7DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1056 59.5098H69.9663V78.8624H70.1056V59.5098Z",
    fill: "#CB7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2448 59.5098H70.1055V78.8624H70.2448V59.5098Z",
    fill: "#CA7AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3842 59.5098H70.2449V78.8624H70.3842V59.5098Z",
    fill: "#CA79F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5223 59.5098H70.3831V78.8624H70.5223V59.5098Z",
    fill: "#C978F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6615 59.5098H70.5222V78.8624H70.6615V59.5098Z",
    fill: "#C977F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8009 59.5098H70.6616V78.8624H70.8009V59.5098Z",
    fill: "#C976F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9403 59.5098H70.801V78.8624H70.9403V59.5098Z",
    fill: "#C875F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0783 59.5098H70.939V78.8624H71.0783V59.5098Z",
    fill: "#C874F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2181 59.5098H71.0789V78.8624H71.2181V59.5098Z",
    fill: "#C773F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3571 59.5098H71.2178V78.8624H71.3571V59.5098Z",
    fill: "#C772F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4962 59.5098H71.3569V78.8624H71.4962V59.5098Z",
    fill: "#C771F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6349 59.5098H71.4956V78.8624H71.6349V59.5098Z",
    fill: "#C670F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7738 59.5098H71.6345V78.8624H71.7738V59.5098Z",
    fill: "#C66FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.913 59.5098H71.7737V78.8624H71.913V59.5098Z",
    fill: "#C56EF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0526 59.5098H71.9133V78.8624H72.0526V59.5098Z",
    fill: "#C56DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1918 59.5098H72.0525V78.8624H72.1918V59.5098Z",
    fill: "#C46CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.33 59.5098H72.1907V78.8624H72.33V59.5098Z",
    fill: "#C46BF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4696 59.5098H72.3303V78.8624H72.4696V59.5098Z",
    fill: "#C46AF6"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65771 89.5757H14.0517L21.7087 110.222H17.0587L15.3847 105.51H7.26271L5.68171 110.222H1.09371L8.65771 89.5757ZM14.0517 101.666L11.2617 93.7607L8.56471 101.666H14.0517ZM31.3717 110.687C28.7264 110.687 26.6701 109.984 25.2027 108.579C23.7561 107.173 23.0327 105.189 23.0327 102.627C23.0327 100.891 23.3737 99.3613 24.0557 98.0387C24.7377 96.6953 25.6987 95.662 26.9387 94.9387C28.1787 94.1947 29.6151 93.8227 31.2477 93.8227C32.0124 93.8227 32.8081 93.9157 33.6347 94.1017C34.4821 94.267 35.1331 94.4633 35.5877 94.6907L34.7507 98.3797C34.2754 98.1523 33.7484 97.9767 33.1697 97.8527C32.6117 97.708 32.0847 97.6357 31.5887 97.6357C30.3074 97.6357 29.2741 98.0697 28.4887 98.9377C27.7241 99.8057 27.3417 100.953 27.3417 102.379C27.3417 103.825 27.7344 104.941 28.5197 105.727C29.3257 106.512 30.4624 106.905 31.9297 106.905C32.9011 106.905 33.9447 106.719 35.0607 106.347L35.7117 109.881C34.3684 110.418 32.9217 110.687 31.3717 110.687ZM45.1091 110.687C43.6211 110.687 42.4638 110.315 41.6371 109.571C40.8311 108.806 40.4281 107.731 40.4281 106.347V98.0077H37.9481V94.2567H40.4281V90.8467C41.8954 90.5987 43.3421 90.4127 44.7681 90.2887V94.2567H48.7981V98.0077H44.7681V105.541C44.7681 105.975 44.8921 106.305 45.1401 106.533C45.4088 106.76 45.7808 106.874 46.2561 106.874C46.8348 106.874 47.4961 106.739 48.2401 106.471L49.2011 109.757C47.8784 110.377 46.5144 110.687 45.1091 110.687ZM54.158 87.5917H59.149V91.6217H54.158V87.5917ZM51.74 106.471H54.716V98.0077H51.74V94.2567H59.087V106.471H61.753V110.222H51.74V106.471ZM71.7248 110.687C70.1128 110.687 68.6868 110.335 67.4468 109.633C66.2275 108.93 65.2768 107.948 64.5948 106.688C63.9128 105.406 63.5718 103.929 63.5718 102.255C63.5718 100.581 63.9025 99.1133 64.5638 97.8527C65.2458 96.5713 66.1965 95.5793 67.4158 94.8767C68.6558 94.174 70.0818 93.8227 71.6938 93.8227C73.3058 93.8227 74.7215 94.174 75.9408 94.8767C77.1808 95.5587 78.1315 96.53 78.7928 97.7907C79.4748 99.0513 79.8158 100.508 79.8158 102.162C79.8158 103.836 79.4748 105.324 78.7928 106.626C78.1315 107.907 77.1808 108.909 75.9408 109.633C74.7215 110.335 73.3161 110.687 71.7248 110.687ZM71.6938 106.905C72.8098 106.905 73.6985 106.481 74.3598 105.634C75.0418 104.766 75.3828 103.629 75.3828 102.224C75.3828 100.818 75.0418 99.7023 74.3598 98.8757C73.6985 98.0283 72.8098 97.6047 71.6938 97.6047C70.5778 97.6047 69.6788 98.0283 68.9968 98.8757C68.3355 99.7023 68.0048 100.818 68.0048 102.224C68.0048 103.629 68.3355 104.766 68.9968 105.634C69.6788 106.481 70.5778 106.905 71.6938 106.905ZM83.0558 94.2567H87.3338V97.0157C87.9951 95.9203 88.7598 95.1143 89.6278 94.5977C90.4958 94.081 91.5084 93.8227 92.6658 93.8227C94.3811 93.8227 95.7244 94.3393 96.6958 95.3727C97.6671 96.3853 98.1528 97.801 98.1528 99.6197V110.222H93.7818V100.302C93.7818 99.475 93.5751 98.8343 93.1618 98.3797C92.7484 97.9043 92.1904 97.6667 91.4878 97.6667C90.6611 97.6667 89.8758 97.9767 89.1318 98.5967C88.3878 99.2167 87.8194 100.002 87.4268 100.953V110.222H83.0558V94.2567ZM102.192 89.5757C102.792 89.555 103.928 89.5447 105.602 89.5447C107.297 89.5447 108.444 89.555 109.043 89.5757C111.172 89.617 112.846 90.1853 114.065 91.2807C115.285 92.376 115.894 93.895 115.894 95.8377C115.894 97.2223 115.584 98.452 114.964 99.5267C114.344 100.581 113.466 101.397 112.329 101.976C111.213 102.554 109.942 102.844 108.516 102.844H106.501V110.222H102.192V89.5757ZM108.33 99.1857C109.343 99.1857 110.128 98.8963 110.686 98.3177C111.265 97.739 111.554 96.9537 111.554 95.9617C111.554 94.143 110.552 93.2337 108.547 93.2337H106.501V99.1857H108.33ZM119.145 89.5757H123.64V106.316H131.08V110.222H119.145V89.5757ZM138.717 95.6517L137.415 110.222H133.416L135.369 89.5757H140.949L146.219 104.394L151.334 89.5757H156.914L158.805 110.222H154.775L153.349 95.7137L147.893 110.439L144.204 110.78L138.717 95.6517Z",
    fill: "#595959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2453_55060",
    transform: "scale(0.0142857 0.0126582)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2453_55060",
    x1: 42.3826,
    y1: 56.0132,
    x2: 72.3971,
    y2: 56.0132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E482FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B950F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AD4AEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8D3CE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5B26CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5624C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2453_55060",
    x1: 65.9007,
    y1: 9.3207,
    x2: 120.1,
    y2: 63.9924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D6AAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D29AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B950F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AD49EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8E36CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6B22B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#4D1591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3D0E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2453_55060",
    x1: 99.8839,
    y1: 49.0221,
    x2: 126.958,
    y2: 95.0949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2453_55060",
    width: 70,
    height: 79,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelogo);
export default __webpack_public_path__ + "static/media/homelogo.db01631bbee90aedab326a2dfec95805.svg";
export { ForwardRef as ReactComponent };